import { AssistantFilter } from '@vi-iot/client/apis/assistant/assistant.api-model';

export const assistantEnFiltersMockData: AssistantFilter[] = [
  {
    attribute: 'esc_Languages',
    label: 'Languages',
    dataType: 'string',
    concepts: [
      {
        id: 'cs',
        parentId: '',
        count: 12967,
        label: 'Czech',
        hasChildren: false,
      },
      {
        id: 'da',
        parentId: '',
        count: 12137,
        label: 'Danish',
        hasChildren: false,
      },
      {
        id: 'nl',
        parentId: '',
        count: 25557,
        label: 'Dutch',
        hasChildren: false,
      },
      {
        id: 'en',
        parentId: '',
        count: 11027,
        label: 'English',
        hasChildren: false,
      },
      {
        id: 'fi',
        parentId: '',
        count: 3176,
        label: 'Finnish',
        hasChildren: false,
      },
      {
        id: 'fr',
        parentId: '',
        count: 49539,
        label: 'French',
        hasChildren: false,
      },
      {
        id: 'de',
        parentId: '',
        count: 57876,
        label: 'German',
        hasChildren: false,
      },
      {
        id: 'it',
        parentId: '',
        count: 18539,
        label: 'Italian',
        hasChildren: false,
      },
      {
        id: 'pl',
        parentId: '',
        count: 12574,
        label: 'Polish',
        hasChildren: false,
      },
      {
        id: 'sk',
        parentId: '',
        count: 9149,
        label: 'Slovak',
        hasChildren: false,
      },
      {
        id: 'sv',
        parentId: '',
        count: 9685,
        label: 'Swedish',
        hasChildren: false,
      },
    ],
  },
  {
    attribute: 'InformationType',
    label: 'Document type',
    class: 'InformationType',
    dataType: 'taxonomy',
    concepts: [
      {
        id: 'Checklists',
        parentId: '',
        count: 10925,
        label: 'Checklists',
        hasChildren: true,
      },
      {
        id: 'Checklists\u001fVCL',
        parentId: 'Checklists',
        count: 310,
        label: 'Sales checklists',
        hasChildren: false,
      },
      {
        id: 'Checklists\u001fWCL',
        parentId: 'Checklists',
        count: 10615,
        label: 'Maintenance checklists',
        hasChildren: false,
      },
      {
        id: 'Data sheets',
        parentId: '',
        count: 11557,
        label: 'Data sheets',
        hasChildren: true,
      },
      {
        id: 'Data sheets\u001fSID',
        parentId: 'Data sheets',
        count: 63,
        label: 'Safety data sheets',
        hasChildren: false,
      },
      {
        id: 'Data sheets\u001fVDP',
        parentId: 'Data sheets',
        count: 11494,
        label: 'Data sheet',
        hasChildren: false,
      },
      {
        id: 'General service information',
        parentId: '',
        count: 164,
        label: 'General service information',
        hasChildren: false,
      },
      {
        id: 'Manuals',
        parentId: '',
        count: 137021,
        label: 'Manuals',
        hasChildren: true,
      },
      {
        id: 'Manuals\u001fVAB',
        parentId: 'Manuals',
        count: 567,
        label: 'Application examples',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVAP',
        parentId: 'Manuals',
        count: 2887,
        label: 'Connection and wiring diagram',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVBA',
        parentId: 'Manuals',
        count: 13117,
        label: 'Operating instructions',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVMA',
        parentId: 'Manuals',
        count: 78077,
        label: 'Technical data manual',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVPA',
        parentId: 'Manuals',
        count: 3106,
        label: 'Planning guide',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVSA',
        parentId: 'Manuals',
        count: 39266,
        label: 'Service instructions',
        hasChildren: false,
      },
      {
        id: 'Q-In-Goodwill/Recall',
        parentId: '',
        count: 1,
        label: 'Q-In-Goodwill/Recall',
        hasChildren: false,
      },
      {
        id: 'Solution database',
        parentId: '',
        count: 639,
        label: 'Solution database',
        hasChildren: true,
      },
      {
        id: 'Solution database\u001fError description',
        parentId: 'Solution database',
        count: 44,
        label: 'Error description',
        hasChildren: false,
      },
      {
        id: 'Solution database\u001fTD-Doku',
        parentId: 'Solution database',
        count: 2,
        label: 'TD-Doku',
        hasChildren: true,
      },
      {
        id: 'Solution database\u001fTD-Doku\u001fTD_Doku_010',
        parentId: 'Solution database\u001fTD-Doku',
        count: 2,
        label: 'Pumps',
        hasChildren: false,
      },
      {
        id: 'Solution database\u001fTD-TIPs',
        parentId: 'Solution database',
        count: 1,
        label: 'TD-TIPs',
        hasChildren: false,
      },
      {
        id: 'Solution database\u001fTDT',
        parentId: 'Solution database',
        count: 1,
        label: 'Support news DE',
        hasChildren: false,
      },
      {
        id: 'Solution database\u001fWorkflow',
        parentId: 'Solution database',
        count: 593,
        label: 'Workflow',
        hasChildren: false,
      },
      {
        id: 'VBD',
        parentId: '',
        count: 42,
        label: 'Operating document',
        hasChildren: false,
      },
      {
        id: 'VET',
        parentId: '',
        count: 5527,
        label: 'Individual parts list',
        hasChildren: false,
      },
      {
        id: 'VKE',
        parentId: '',
        count: 664,
        label: 'EU Declaration of conformity',
        hasChildren: false,
      },
      {
        id: 'Video',
        parentId: '',
        count: 30,
        label: 'Video',
        hasChildren: false,
      },
    ],
  },
  {
    attribute: 'product',
    label: 'Product',
    class: 'product',
    dataType: 'taxonomy',
    concepts: [
      {
        id: 'Accessories/System technology',
        parentId: '',
        count: 7561,
        label: 'Accessories/System technology',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fCommunication',
        parentId: 'Accessories/System technology',
        count: 2301,
        label: 'Communication',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fViScada Gateway',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 51,
        label: 'ViScada Gateway',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitocom 100',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 761,
        label: 'Vitocom 100',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitocom 200',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 179,
        label: 'Vitocom 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitocom 300',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 294,
        label: 'Vitocom 300',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitoconnect',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 274,
        label: 'Vitoconnect',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitoconnect 100',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 419,
        label: 'Vitoconnect 100',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitoconnect 200',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 48,
        label: 'Vitoconnect 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitogate 200',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 194,
        label: 'Vitogate 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitogate 300',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 262,
        label: 'Vitogate 300',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical',
        parentId: 'Accessories/System technology',
        count: 4143,
        label: 'Electrical',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        parentId: 'Accessories/System technology\u001fElectrical',
        count: 3702,
        label: 'Remote controls',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 1351,
        label: 'Vitotrol 100',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100-E',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 198,
        label: 'Vitotrol 100-E',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100-EH',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 105,
        label: 'Vitotrol 100-EH',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100-M',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 34,
        label: 'Vitotrol 100-M',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100-OT',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 219,
        label: 'Vitotrol 100-OT',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 200',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 307,
        label: 'Vitotrol 200',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 200-A',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 63,
        label: 'Vitotrol 200-A',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 200-E',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 227,
        label: 'Vitotrol 200-E',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 200-RF',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 261,
        label: 'Vitotrol 200-RF',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 663,
        label: 'Vitotrol 300',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300-A',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 389,
        label: 'Vitotrol 300-A',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300-B',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 178,
        label: 'Vitotrol 300-B',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300-E',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 180,
        label: 'Vitotrol 300-E',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300-RF',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 235,
        label: 'Vitotrol 300-RF',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 350',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 42,
        label: 'Vitotrol 350',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 350-C',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 85,
        label: 'Vitotrol 350-C',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fHome Automation',
        parentId: 'Accessories/System technology\u001fElectrical',
        count: 465,
        label: 'Home automation',
        hasChildren: true,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fHome Automation\u001fVitocomfort 200',
        parentId: 'Accessories/System technology\u001fElectrical\u001fHome Automation',
        count: 93,
        label: 'Vitocomfort 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fHome Automation\u001fVitohome 200',
        parentId: 'Accessories/System technology\u001fElectrical\u001fHome Automation',
        count: 45,
        label: 'Vitohome 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fHome Automation\u001fVitohome 300',
        parentId: 'Accessories/System technology\u001fElectrical\u001fHome Automation',
        count: 108,
        label: 'Vitohome 300',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fExhaust gas',
        parentId: 'Accessories/System technology',
        count: 353,
        label: 'Exhaust gas',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        parentId: 'Accessories/System technology\u001fExhaust gas',
        count: 353,
        label: 'Exhaust gas/water heat exchanger',
        hasChildren: true,
      },
      {
        id:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger\u001fVitotrans 100-LW',
        parentId:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        count: 33,
        label: 'Vitotrans 100-LW',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger\u001fVitotrans 200-LW',
        parentId:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        count: 33,
        label: 'Vitotrans 200-LW',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger\u001fVitotrans 300',
        parentId:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        count: 291,
        label: 'Vitotrans 300',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger\u001fVitotrans 333',
        parentId:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        count: 89,
        label: 'Vitotrans 333',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic',
        parentId: 'Accessories/System technology',
        count: 799,
        label: 'Hydraulic',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fDivicon',
        parentId: 'Accessories/System technology\u001fHydraulic',
        count: 579,
        label: 'Divicon',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fHydraulic accessories',
        parentId: 'Accessories/System technology\u001fHydraulic',
        count: 40,
        label: 'Hydraulic accessories',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fHydraulic accessories\u001fVitopure',
        parentId: 'Accessories/System technology\u001fHydraulic\u001fHydraulic accessories',
        count: 40,
        label: 'Vitopure',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fPipe-bundle heat exchanger',
        parentId: 'Accessories/System technology\u001fHydraulic',
        count: 120,
        label: 'Pipe-bundle heat exchanger',
        hasChildren: true,
      },
      {
        id:
          'Accessories/System technology\u001fHydraulic\u001fPipe-bundle heat exchanger\u001fVitotrans 200',
        parentId: 'Accessories/System technology\u001fHydraulic\u001fPipe-bundle heat exchanger',
        count: 120,
        label: 'Vitotrans 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers',
        parentId: 'Accessories/System technology\u001fHydraulic',
        count: 82,
        label: 'Plate heat exchangers',
        hasChildren: true,
      },
      {
        id:
          'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers\u001fVitotrans 100',
        parentId: 'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers',
        count: 57,
        label: 'Vitotrans 100',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers\u001fVitotrans EC-Pro',
        parentId: 'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers',
        count: 25,
        label: 'Vitotrans EC-Pro',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fOther',
        parentId: 'Accessories/System technology',
        count: 5,
        label: 'Other',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fOther\u001fContainer systems',
        parentId: 'Accessories/System technology\u001fOther',
        count: 5,
        label: 'Container systems',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fOther\u001fContainer systems\u001fVitomodul',
        parentId: 'Accessories/System technology\u001fOther\u001fContainer systems',
        count: 1,
        label: 'Vitomodul',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fOther\u001fContainer systems\u001fVitomodul 200',
        parentId: 'Accessories/System technology\u001fOther\u001fContainer systems',
        count: 1,
        label: 'Vitomodul 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fOther\u001fContainer systems\u001fVitomodul 200-W',
        parentId: 'Accessories/System technology\u001fOther\u001fContainer systems',
        count: 4,
        label: 'Vitomodul 200-W',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems',
        parentId: '',
        count: 5458,
        label: 'Air conditioning and cooling systems',
        hasChildren: true,
      },
      {
        id: 'Air conditioning and cooling systems\u001fAir conditioners',
        parentId: 'Air conditioning and cooling systems',
        count: 5276,
        label: 'Air conditioners',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners',
        count: 909,
        label: 'Multisplit air conditioners',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners\u001fVitoclima 300-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners',
        count: 354,
        label: 'Vitoclima 300-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners\u001fVitoclima 300-S/HE',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners',
        count: 572,
        label: 'Vitoclima 300-S/HE',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners',
        count: 340,
        label: 'Single Split commercial (LCAC)',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)\u001fVitoclima 100-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)',
        count: 142,
        label: 'Vitoclima 100-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)\u001fVitoclima 242-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)',
        count: 198,
        label: 'Vitoclima 242-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners',
        count: 1146,
        label: 'Single Split residential (RAC)',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 200-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 446,
        label: 'Vitoclima 200-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 200-S/HE',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 562,
        label: 'Vitoclima 200-S/HE',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 220-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 72,
        label: 'Vitoclima 220-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 230-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 76,
        label: 'Vitoclima 230-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 232-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 3,
        label: 'Vitoclima 232-S',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners',
        count: 3000,
        label: 'VRF commercial',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial\u001fVitoclima 333-S',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial',
        count: 1920,
        label: 'Vitoclima 333-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial\u001fVitoclima 335-S',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial',
        count: 1080,
        label: 'Vitoclima 335-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial\u001fVitoclima 444-S',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial',
        count: 108,
        label: 'Vitoclima 444-S',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems\u001fCold water sets',
        parentId: 'Air conditioning and cooling systems',
        count: 114,
        label: 'Cold water sets',
        hasChildren: true,
      },
      {
        id: 'Air conditioning and cooling systems\u001fCold water sets\u001fVitoclima 200-C',
        parentId: 'Air conditioning and cooling systems\u001fCold water sets',
        count: 114,
        label: 'Vitoclima 200-C',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems\u001fCold water sets\u001fVitoclima-C',
        parentId: 'Air conditioning and cooling systems\u001fCold water sets',
        count: 15,
        label: 'Vitoclima-C',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems\u001fCommercial cooling systems',
        parentId: 'Air conditioning and cooling systems',
        count: 71,
        label: 'Commercial cooling systems',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing',
        parentId: 'Air conditioning and cooling systems\u001fCommercial cooling systems',
        count: 71,
        label: 'Ceiling units for normal and deep-freezing',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing\u001fLidl Mopro',
        parentId:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing',
        count: 29,
        label: 'Lidl Mopro',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing\u001fTecto Refrigo D',
        parentId:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing',
        count: 42,
        label: 'Tecto Refrigo D',
        hasChildren: false,
      },
      {
        id: 'Burners',
        parentId: '',
        count: 1768,
        label: 'Burners',
        hasChildren: true,
      },
      {
        id: 'Burners\u001fDurotwin',
        parentId: 'Burners',
        count: 6,
        label: 'Durotwin',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners',
        parentId: 'Burners',
        count: 1762,
        label: 'Oil burners',
        hasChildren: true,
      },
      {
        id: 'Burners\u001fOil burners\u001fCaloflame 100',
        parentId: 'Burners\u001fOil burners',
        count: 26,
        label: 'Caloflame 100',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners\u001fCaloflame 200',
        parentId: 'Burners\u001fOil burners',
        count: 25,
        label: 'Caloflame 200',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners\u001fVitoflame 100',
        parentId: 'Burners\u001fOil burners',
        count: 487,
        label: 'Vitoflame 100',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners\u001fVitoflame 200',
        parentId: 'Burners\u001fOil burners',
        count: 552,
        label: 'Vitoflame 200',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners\u001fVitoflame 300',
        parentId: 'Burners\u001fOil burners',
        count: 736,
        label: 'Vitoflame 300',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas',
        parentId: '',
        count: 10371,
        label: 'Commercial and Industrial Boilers oil/gas',
        hasChildren: true,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot and warm water boilers',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 133,
        label: 'Hot and warm water boilers',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fHot and warm water boilers\u001fParomat',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot and warm water boilers',
        count: 133,
        label: 'Paromat',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 369,
        label: 'Hot water boilers',
        hasChildren: true,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 52,
        label: 'Turbomat',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-Duplex',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 41,
        label: 'Turbomat-Duplex',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-R',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 37,
        label: 'Turbomat-R',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-R-NH',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 6,
        label: 'Turbomat-R-NH',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-RN',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 33,
        label: 'Turbomat-RN',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-RN-WD',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 1,
        label: 'Turbomat-RN-WD',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fVitomax 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 189,
        label: 'Vitomax 100',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fVitomax 200-WS',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 85,
        label: 'Vitomax 200-WS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 760,
        label: 'Oil/Gas condensing boilers floor-standing',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing\u001fVitoradial 200-C',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing',
        count: 38,
        label: 'Vitoradial 200-C',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing\u001fVitoradial 300-T',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing',
        count: 735,
        label: 'Vitoradial 300-T',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas special boilers (low press steam)',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 21,
        label: 'Oil/Gas special boilers (low press steam)',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas special boilers (low press steam)\u001fParomat-ND',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas special boilers (low press steam)',
        count: 21,
        label: 'Paromat-ND',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 991,
        label: 'Oil/gas boilers',
        hasChildren: true,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fDuo-Parola-e',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 3,
        label: 'Duo-Parola-e',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fDuo-Parola-eh',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 3,
        label: 'Duo-Parola-eh',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fDuo-parola-et',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 3,
        label: 'Duo-parola-et',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fParomat-RE-ND',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 5,
        label: 'Paromat-RE-ND',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fParomat-RU',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 12,
        label: 'Paromat-RU',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fRondomat',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 96,
        label: 'Rondomat',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fVitocrossal 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 490,
        label: 'Vitocrossal 100',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fVitomax 200',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 348,
        label: 'Vitomax 200',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fVitomax 300',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 73,
        label: 'Vitomax 300',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 1055,
        label: 'Oil/gas deep temperature boilers',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitoCell-uniferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 11,
        label: 'VitoCell-uniferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 180,
        label: 'Vitola 100',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola 200',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 716,
        label: 'Vitola 200',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola 222',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 280,
        label: 'Vitola 222',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola-biferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 113,
        label: 'Vitola-biferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola-biferral-2',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 13,
        label: 'Vitola-biferral-2',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola-biferral-FB',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 55,
        label: 'Vitola-biferral-FB',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola-biferral-RN',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 16,
        label: 'Vitola-biferral-RN',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 1074,
        label: 'Oil/gas high pressure hot water units',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units\u001fTurbomat-RN-HW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        count: 23,
        label: 'Turbomat-RN-HW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units\u001fVitomax 200-HW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        count: 335,
        label: 'Vitomax 200-HW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units\u001fVitomax 300-HW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        count: 91,
        label: 'Vitomax 300-HW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units\u001fVitomax HW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        count: 679,
        label: 'Vitomax HW',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 983,
        label: 'Oil/gas high-pressure steam generator',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fTurbomat-RN-HD',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 25,
        label: 'Turbomat-RN-HD',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax 100-HS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 59,
        label: 'Vitomax 100-HS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax 200-HS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 342,
        label: 'Vitomax 200-HS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax 300-HS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 92,
        label: 'Vitomax 300-HS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax HS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 548,
        label: 'Vitomax HS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax HS-E',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 28,
        label: 'Vitomax HS-E',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 1324,
        label: 'Oil/gas low pressure hot water units',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units\u001fVitomax 100-LW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        count: 186,
        label: 'Vitomax 100-LW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units\u001fVitomax 200-LW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        count: 418,
        label: 'Vitomax 200-LW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units\u001fVitomax 300-LW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        count: 124,
        label: 'Vitomax 300-LW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units\u001fVitomax LW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        count: 834,
        label: 'Vitomax LW',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 535,
        label: 'Oil/gas low pressure steam generator',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator\u001fVitomax 200-LS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator',
        count: 48,
        label: 'Vitomax 200-LS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator\u001fVitomax LS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator',
        count: 27,
        label: 'Vitomax LS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator\u001fVitoplex 100-LS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator',
        count: 478,
        label: 'Vitoplex 100-LS',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 5258,
        label: 'Oil/gas low-temperature boiler',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Duplex',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 58,
        label: 'Paromat-Duplex',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Duplex-TR',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 47,
        label: 'Paromat-Duplex-TR',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Simplex',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 139,
        label: 'Paromat-Simplex',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Triplex',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 135,
        label: 'Paromat-Triplex',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Triplex-Z',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 41,
        label: 'Paromat-Triplex-Z',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoCell',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 77,
        label: 'VitoCell',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoCell-biferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 35,
        label: 'VitoCell-biferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoCell-comferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 29,
        label: 'VitoCell-comferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola 111',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 133,
        label: 'Vitola 111',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-biferral-e',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 27,
        label: 'Vitola-biferral-e',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-comferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 54,
        label: 'Vitola-comferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-s-e',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1,
        label: 'Vitola-s-e',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-tripass',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 33,
        label: 'Vitola-tripass',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-u-e',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 4,
        label: 'Vitola-u-e',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-u-eh',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1,
        label: 'Vitola-u-eh',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-u-et',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 3,
        label: 'Vitola-u-et',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-uniferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 56,
        label: 'Vitola-uniferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitomax 300-LT',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 132,
        label: 'Vitomax 300-LT',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoplex 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 764,
        label: 'Vitoplex 100',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoplex 200',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1096,
        label: 'Vitoplex 200',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoplex 300',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1475,
        label: 'Vitoplex 300',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitorond 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 479,
        label: 'Vitorond 100',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitorond 200',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1215,
        label: 'Vitorond 200',
        hasChildren: false,
      },
      {
        id: 'Controls',
        parentId: '',
        count: 8279,
        label: 'Controls',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control',
        parentId: 'Controls',
        count: 3775,
        label: 'Boiler and heating circuit control',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fCalotronic 200',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 34,
        label: 'Calotronic 200',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fDekamatik-DE/B',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 10,
        label: 'Dekamatik-DE/B',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fDiomatik',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 15,
        label: 'Diomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fOne Base',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 23,
        label: 'One Base',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fTetramatik-MB',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 1,
        label: 'Tetramatik-MB',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 3,
        label: 'Vitotronic',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic 200',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 3075,
        label: 'Vitotronic 200',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic 200-B',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 10,
        label: 'Vitotronic 200-B',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic 200-C',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 11,
        label: 'Vitotronic 200-C',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic 300',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 912,
        label: 'Vitotronic 300',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls',
        parentId: 'Controls',
        count: 3145,
        label: 'Boiler circuit controls',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fCalotronic 100',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 31,
        label: 'Calotronic 100',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fCalotronic 150',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 38,
        label: 'Calotronic 150',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fDuomatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 91,
        label: 'Duomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fEcotronic',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 49,
        label: 'Ecotronic',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fEurolamatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 5,
        label: 'Eurolamatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fMinomatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 13,
        label: 'Minomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fTetramatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 106,
        label: 'Tetramatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fUnomatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 76,
        label: 'Unomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fVitotronic 100',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 2664,
        label: 'Vitotronic 100',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fVitotronic 150',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 90,
        label: 'Vitotronic 150',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fCascade controls',
        parentId: 'Controls',
        count: 882,
        label: 'Cascade controls',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fCascade controls\u001fVitotronic 300-K',
        parentId: 'Controls\u001fCascade controls',
        count: 726,
        label: 'Vitotronic 300-K',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fCascade controls\u001fVitotronic 333',
        parentId: 'Controls\u001fCascade controls',
        count: 178,
        label: 'Vitotronic 333',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fControl accessories',
        parentId: 'Controls',
        count: 78,
        label: 'Control accessories',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fControl accessories\u001fControl panels',
        parentId: 'Controls\u001fControl accessories',
        count: 66,
        label: 'Control panels',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fControl accessories\u001fControl panels\u001fComfortrol',
        parentId: 'Controls\u001fControl accessories\u001fControl panels',
        count: 66,
        label: 'Comfortrol',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fControl accessories\u001fSensors',
        parentId: 'Controls\u001fControl accessories',
        count: 12,
        label: 'Sensors',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fControl accessories\u001fSensors\u001fOutdoor temperature sensor',
        parentId: 'Controls\u001fControl accessories\u001fSensors',
        count: 3,
        label: 'Outdoor temperature sensor',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fHeating circuit control',
        parentId: 'Controls',
        count: 757,
        label: 'Heating circuit control',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fHeating circuit control\u001fMotomatik',
        parentId: 'Controls\u001fHeating circuit control',
        count: 29,
        label: 'Motomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fHeating circuit control\u001fVitotronic 050',
        parentId: 'Controls\u001fHeating circuit control',
        count: 249,
        label: 'Vitotronic 050',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fHeating circuit control\u001fVitotronic 200-H',
        parentId: 'Controls\u001fHeating circuit control',
        count: 492,
        label: 'Vitotronic 200-H',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSolar controls',
        parentId: 'Controls',
        count: 824,
        label: 'Solar controls',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fSolar controls\u001fSolartrol-E',
        parentId: 'Controls\u001fSolar controls',
        count: 5,
        label: 'Solartrol-E',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSolar controls\u001fSolartrol-M',
        parentId: 'Controls\u001fSolar controls',
        count: 4,
        label: 'Solartrol-M',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSolar controls\u001fVitosolic 100',
        parentId: 'Controls\u001fSolar controls',
        count: 447,
        label: 'Vitosolic 100',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSolar controls\u001fVitosolic 200',
        parentId: 'Controls\u001fSolar controls',
        count: 374,
        label: 'Vitosolic 200',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSystem control',
        parentId: 'Controls',
        count: 215,
        label: 'System control',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fSystem control\u001fVitocontrol 100-M',
        parentId: 'Controls\u001fSystem control',
        count: 184,
        label: 'Vitocontrol 100-M',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSystem control\u001fVitocontrol 200-M',
        parentId: 'Controls\u001fSystem control',
        count: 31,
        label: 'Vitocontrol 200-M',
        hasChildren: false,
      },
      {
        id: 'Electric heating systems',
        parentId: '',
        count: 94,
        label: 'Electric heating systems',
        hasChildren: true,
      },
      {
        id: 'Electric heating systems\u001fElectric Boilers',
        parentId: 'Electric heating systems',
        count: 94,
        label: 'Electric Boilers',
        hasChildren: true,
      },
      {
        id: 'Electric heating systems\u001fElectric Boilers\u001fVitotron 100',
        parentId: 'Electric heating systems\u001fElectric Boilers',
        count: 94,
        label: 'Vitotron 100',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling',
        parentId: '',
        count: 8558,
        label: 'Force and heat coupling',
        hasChildren: true,
      },
      {
        id: 'Force and heat coupling\u001fCombined heat and power',
        parentId: 'Force and heat coupling',
        count: 5423,
        label: 'Combined heat and power',
        hasChildren: true,
      },
      {
        id: 'Force and heat coupling\u001fCombined heat and power\u001fVitobloc',
        parentId: 'Force and heat coupling\u001fCombined heat and power',
        count: 160,
        label: 'Vitobloc',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fCombined heat and power\u001fVitobloc 200',
        parentId: 'Force and heat coupling\u001fCombined heat and power',
        count: 5410,
        label: 'Vitobloc 200',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via Stirling',
        parentId: 'Force and heat coupling',
        count: 1345,
        label: 'Micro-cogeneration via Stirling',
        hasChildren: true,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via Stirling\u001fMikron 300-W',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via Stirling',
        count: 15,
        label: 'Mikron 300-W',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via Stirling\u001fVitotwin 300-W',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via Stirling',
        count: 1267,
        label: 'Vitotwin 300-W',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via Stirling\u001fVitotwin 350-F',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via Stirling',
        count: 179,
        label: 'Vitotwin 350-F',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells',
        parentId: 'Force and heat coupling',
        count: 1915,
        label: 'Micro-cogeneration via fuel cells',
        hasChildren: true,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells\u001fVitovalor 300-P',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells',
        count: 563,
        label: 'Vitovalor 300-P',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells\u001fVitovalor PA2',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells',
        count: 307,
        label: 'Vitovalor PA2',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells\u001fVitovalor PT2',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells',
        count: 1113,
        label: 'Vitovalor PT2',
        hasChildren: false,
      },
      {
        id: 'Gas boilers',
        parentId: '',
        count: 37422,
        label: 'Gas boilers',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted',
        parentId: 'Gas boilers',
        count: 3098,
        label: 'Gas Boilers wall-mounted',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas boilers conventional',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 745,
        label: 'Gas boilers conventional',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas boilers conventional\u001fVitopend 100',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas boilers conventional',
        count: 745,
        label: 'Vitopend 100',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 1917,
        label: 'Gas combi or direct water heaters',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters\u001fPendola',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters',
        count: 104,
        label: 'Pendola',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters\u001fVitopend 100-W',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters',
        count: 1354,
        label: 'Vitopend 100-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters\u001fVitopend 200',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters',
        count: 521,
        label: 'Vitopend 200',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi unit for wall integration',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 62,
        label: 'Gas combi unit for wall integration',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi unit for wall integration\u001fVitopend 100-E',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi unit for wall integration',
        count: 62,
        label: 'Vitopend 100-E',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 817,
        label: 'Gas combi water unit',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit\u001fVitopend 050',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit',
        count: 18,
        label: 'Vitopend 050',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit\u001fVitopend 050-W',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit',
        count: 53,
        label: 'Vitopend 050-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit\u001fVitopend 200-W',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit',
        count: 789,
        label: 'Vitopend 200-W',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 198,
        label: 'Gas water heater with storage tank',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank\u001fVitopend 222',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank',
        count: 125,
        label: 'Vitopend 222',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank\u001fVitopend 222-W',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank',
        count: 134,
        label: 'Vitopend 222-W',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas adsorption unit',
        parentId: 'Gas boilers',
        count: 576,
        label: 'Gas adsorption unit',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas adsorption unit\u001fVitosorp 200',
        parentId: 'Gas boilers\u001fGas adsorption unit',
        count: 51,
        label: 'Vitosorp 200',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas adsorption unit\u001fVitosorp 200-F',
        parentId: 'Gas boilers\u001fGas adsorption unit',
        count: 576,
        label: 'Vitosorp 200-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing',
        parentId: 'Gas boilers',
        count: 1898,
        label: 'Gas boilers floor standing',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtmola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 7,
        label: 'Atmola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtmotherm',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 3,
        label: 'Atmotherm',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 240,
        label: 'Atola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtola-Kompakt',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 25,
        label: 'Atola-Kompakt',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtola-RN',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 142,
        label: 'Atola-RN',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fGasola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 33,
        label: 'Gasola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fLitola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 138,
        label: 'Litola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fLitola-CL',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 27,
        label: 'Litola-CL',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fRexola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 7,
        label: 'Rexola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fRexola-biferral',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 66,
        label: 'Rexola-biferral',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fRexola-triferral',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 50,
        label: 'Rexola-triferral',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fRondola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 3,
        label: 'Rondola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 050',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 86,
        label: 'Vitogas 050',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 100',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 528,
        label: 'Vitogas 100',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 100-F',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 415,
        label: 'Vitogas 100-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 200',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 105,
        label: 'Vitogas 200',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 200-F',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 491,
        label: 'Vitogas 200-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 300',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 47,
        label: 'Vitogas 300',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas compact devices',
        parentId: 'Gas boilers',
        count: 12989,
        label: 'Gas compact devices',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        parentId: 'Gas boilers\u001fGas compact devices',
        count: 10199,
        label: 'Gas condensing compact unit',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 111-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 448,
        label: 'Vitodens 111-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 111-W',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 1775,
        label: 'Vitodens 111-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 222',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 296,
        label: 'Vitodens 222',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 222-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 4954,
        label: 'Vitodens 222-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 222-W',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 3475,
        label: 'Vitodens 222-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 333',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 410,
        label: 'Vitodens 333',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 333-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 1788,
        label: 'Vitodens 333-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        parentId: 'Gas boilers\u001fGas compact devices',
        count: 4320,
        label: 'Gas condensing/Compact solar units',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitodens 141-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 187,
        label: 'Vitodens 141-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitodens 242-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 2564,
        label: 'Vitodens 242-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitodens 343',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 151,
        label: 'Vitodens 343',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitodens 343-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 1489,
        label: 'Vitodens 343-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitosolar 200-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 252,
        label: 'Vitosolar 200-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitosolar 300-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 636,
        label: 'Vitosolar 300-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas compact devices\u001fGas heating value compact unit',
        parentId: 'Gas boilers\u001fGas compact devices',
        count: 181,
        label: 'Gas heating value compact unit',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas heating value compact unit\u001fVitopend 111-W',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas heating value compact unit',
        count: 181,
        label: 'Vitopend 111-W',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing',
        parentId: 'Gas boilers',
        count: 6374,
        label: 'Gas condensing boiler floor-standing',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fCondensola',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 113,
        label: 'Condensola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVertomat',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 128,
        label: 'Vertomat',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVertomat-Simplex',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 31,
        label: 'Vertomat-Simplex',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVitocrossal',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 1189,
        label: 'Vitocrossal',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVitocrossal 200',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 1778,
        label: 'Vitocrossal 200',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVitocrossal 300',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 4033,
        label: 'Vitocrossal 300',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        parentId: 'Gas boilers',
        count: 16573,
        label: 'Gas condensing boiler wall-mounted',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing boiler for wall installation',
        parentId: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        count: 362,
        label: 'Gas condensing boiler for wall installation',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing boiler for wall installation\u001fVitodens 100-E',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing boiler for wall installation',
        count: 362,
        label: 'Vitodens 100-E',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit',
        parentId: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        count: 1909,
        label: 'Gas condensing combi unit',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit\u001fVitodens 050-T',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit',
        count: 68,
        label: 'Vitodens 050-T',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit\u001fVitodens 050-W',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit',
        count: 1877,
        label: 'Vitodens 050-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        parentId: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        count: 12937,
        label: 'Gas condensing combi/heating unit',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 286,
        label: 'Vitodens',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens 100',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 543,
        label: 'Vitodens 100',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens 100-W',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 3482,
        label: 'Vitodens 100-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens 200',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 1031,
        label: 'Vitodens 200',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens 200-W',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 8976,
        label: 'Vitodens 200-W',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        parentId: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        count: 2987,
        label: 'Gas condensing heating unit',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fCondutherm',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 1,
        label: 'Condutherm',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fEurola',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 127,
        label: 'Eurola',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fEurola-CB',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 9,
        label: 'Eurola-CB',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fMirola',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 25,
        label: 'Mirola',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fVitodens 300',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 613,
        label: 'Vitodens 300',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fVitodens 300-W',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 2362,
        label: 'Vitodens 300-W',
        hasChildren: false,
      },
      {
        id: 'Gas-Heizkessel',
        parentId: '',
        count: 2,
        label: 'Gas-Heizkessel',
        hasChildren: true,
      },
      {
        id: 'Gas-Heizkessel\u001fGas-Kompaktgeräte',
        parentId: 'Gas-Heizkessel',
        count: 2,
        label: 'Gas-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id: 'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-/Solar-Kompaktgeräte',
        parentId: 'Gas-Heizkessel\u001fGas-Kompaktgeräte',
        count: 1,
        label: 'Gas-Brennwert-/Solar-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-/Solar-Kompaktgeräte\u001fVitodens 242-F',
        parentId: 'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-/Solar-Kompaktgeräte',
        count: 1,
        label: 'Vitodens 242-F',
        hasChildren: false,
      },
      {
        id: 'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-Kompaktgeräte',
        parentId: 'Gas-Heizkessel\u001fGas-Kompaktgeräte',
        count: 1,
        label: 'Gas-Brennwert-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-Kompaktgeräte\u001fVitodens 111-F',
        parentId: 'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-Kompaktgeräte',
        count: 1,
        label: 'Vitodens 111-F',
        hasChildren: false,
      },
      {
        id: 'HEMS',
        parentId: '',
        count: 54,
        label: 'Vi Energy Management',
        hasChildren: false,
      },
      {
        id: 'Heat pumps',
        parentId: '',
        count: 19212,
        label: 'Heat pumps',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps',
        parentId: 'Heat pumps',
        count: 6521,
        label: 'Air/water heat pumps',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 150-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 942,
        label: 'Vitocal 150-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 151-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 709,
        label: 'Vitocal 151-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 200-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 1897,
        label: 'Vitocal 200-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 200-A PRO',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 133,
        label: 'Vitocal 200-A PRO',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 222-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 533,
        label: 'Vitocal 222-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 250-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 1561,
        label: 'Vitocal 250-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 250-A Pro',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 1,
        label: 'Vitocal 250-A Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 252-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 846,
        label: 'Vitocal 252-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 300-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 1741,
        label: 'Vitocal 300-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 350',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 136,
        label: 'Vitocal 350',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 350-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 955,
        label: 'Vitocal 350-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/ water/ air heat pumps',
        parentId: 'Heat pumps',
        count: 304,
        label: 'Brine/water/air heat pumps',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fBrine/ water/ air heat pumps\u001fVitocal 300',
        parentId: 'Heat pumps\u001fBrine/ water/ air heat pumps',
        count: 304,
        label: 'Vitocal 300',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps',
        parentId: 'Heat pumps',
        count: 5911,
        label: 'Brine/water heat pumps',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fNatura',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 203,
        label: 'Natura',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fSwissline',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 75,
        label: 'Swissline',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 200-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 1502,
        label: 'Vitocal 200-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 222-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 1394,
        label: 'Vitocal 222-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 242-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 756,
        label: 'Vitocal 242-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 300-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 2129,
        label: 'Vitocal 300-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 333-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 1138,
        label: 'Vitocal 333-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 343',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 141,
        label: 'Vitocal 343',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 343-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 756,
        label: 'Vitocal 343-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 350-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 1035,
        label: 'Vitocal 350-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 350-HT Pro',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 90,
        label: 'Vitocal 350-HT Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fe-Natura 350-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 41,
        label: 'e-Natura 350-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fCompact-Energy-Tower',
        parentId: 'Heat pumps',
        count: 54,
        label: 'Compact Energy Tower',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fCompact-Energy-Tower\u001fVitotres 343',
        parentId: 'Heat pumps\u001fCompact-Energy-Tower',
        count: 54,
        label: 'Vitotres 343',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps',
        parentId: 'Heat pumps',
        count: 2021,
        label: 'Hot water heat pumps',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fViessmann DHW Booster HP',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 114,
        label: 'Viessmann DHW Booster HP',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 060-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 873,
        label: 'Vitocal 060-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 060-S',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 6,
        label: 'Vitocal 060-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 061-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 6,
        label: 'Vitocal 061-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 160-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 200,
        label: 'Vitocal 160-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 161-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 147,
        label: 'Vitocal 161-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 162-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 9,
        label: 'Vitocal 162-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 262-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 851,
        label: 'Vitocal 262-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fIce energy storage',
        parentId: 'Heat pumps',
        count: 32,
        label: 'Ice energy storage',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fIce energy storage\u001fVitofriocal',
        parentId: 'Heat pumps\u001fIce energy storage',
        count: 32,
        label: 'Vitofriocal',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps',
        parentId: 'Heat pumps',
        count: 520,
        label: 'Large heat pumps',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 300-G Pro',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 383,
        label: 'Vitocal 300-G Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 300-G Pro SPS',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 74,
        label: 'Vitocal 300-G Pro SPS',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 300-W Pro',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 98,
        label: 'Vitocal 300-W Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 300-W Pro SPS',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 50,
        label: 'Vitocal 300-W Pro SPS',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 350-G Pro',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 178,
        label: 'Vitocal 350-G Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 350-W',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 5,
        label: 'Vitocal 350-W',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 350-W Pro',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 8,
        label: 'Vitocal 350-W Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps',
        parentId: 'Heat pumps',
        count: 5731,
        label: 'Split air/water heat pumps',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fNatura 200-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 52,
        label: 'Natura 200-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 100',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 51,
        label: 'Vitocal 100',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 100-A',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 337,
        label: 'Vitocal 100-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 100-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 806,
        label: 'Vitocal 100-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 111-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 615,
        label: 'Vitocal 111-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 200-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 3747,
        label: 'Vitocal 200-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 222-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 2190,
        label: 'Vitocal 222-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 222-SI',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 617,
        label: 'Vitocal 222-SI',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 242-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 787,
        label: 'Vitocal 242-S',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices',
        parentId: '',
        count: 2386,
        label: 'Hybrid devices',
        hasChildren: true,
      },
      {
        id: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation',
        parentId: 'Hybrid devices',
        count: 1853,
        label: 'Air/water heat pumps/hybrid operation',
        hasChildren: true,
      },
      {
        id: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation\u001fVitocal 250-AH',
        parentId: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation',
        count: 851,
        label: 'Vitocal 250-AH',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation\u001fVitocal 250-S',
        parentId: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation',
        count: 496,
        label: 'Vitocal 250-S',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation\u001fVitocal 250-SH',
        parentId: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation',
        count: 617,
        label: 'Vitocal 250-SH',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices\u001fGas hybrid compact devices',
        parentId: 'Hybrid devices',
        count: 735,
        label: 'Gas hybrid compact devices',
        hasChildren: true,
      },
      {
        id: 'Hybrid devices\u001fGas hybrid compact devices\u001fVitocaldens 222-F',
        parentId: 'Hybrid devices\u001fGas hybrid compact devices',
        count: 735,
        label: 'Vitocaldens 222-F',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices\u001fOil hybrid compact unit',
        parentId: 'Hybrid devices',
        count: 291,
        label: 'Oil hybrid compact unit',
        hasChildren: true,
      },
      {
        id: 'Hybrid devices\u001fOil hybrid compact unit\u001fVitolacaldens 222-F',
        parentId: 'Hybrid devices\u001fOil hybrid compact unit',
        count: 291,
        label: 'Vitolacaldens 222-F',
        hasChildren: false,
      },
      {
        id: 'Light commercial ventilation systems',
        parentId: '',
        count: 318,
        label: 'Light commercial ventilation systems',
        hasChildren: true,
      },
      {
        id: 'Light commercial ventilation systems\u001fVitoair CS PRO',
        parentId: 'Light commercial ventilation systems',
        count: 160,
        label: 'Vitoair CS PRO',
        hasChildren: false,
      },
      {
        id: 'Light commercial ventilation systems\u001fVitoair CT PRO',
        parentId: 'Light commercial ventilation systems',
        count: 45,
        label: 'Vitoair CT PRO',
        hasChildren: false,
      },
      {
        id: 'Light commercial ventilation systems\u001fVitoair FS PRO',
        parentId: 'Light commercial ventilation systems',
        count: 163,
        label: 'Vitoair FS PRO',
        hasChildren: false,
      },
      {
        id: 'Oil boilers',
        parentId: '',
        count: 5639,
        label: 'Oil boilers',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing',
        parentId: 'Oil boilers',
        count: 430,
        label: 'Oil boilers floor-standing',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers',
        parentId: 'Oil boilers\u001fOil boilers floor-standing',
        count: 77,
        label: 'Changeover boilers',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers\u001fCalora 050',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers',
        count: 50,
        label: 'Calora 050',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers\u001fCalora 055',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers',
        count: 20,
        label: 'Calora 055',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers\u001fVitola 055',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers',
        count: 12,
        label: 'Vitola 055',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fOil deep temperature boilers',
        parentId: 'Oil boilers\u001fOil boilers floor-standing',
        count: 33,
        label: 'Oil deep temperature boilers',
        hasChildren: true,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil deep temperature boilers\u001fVitola 300',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil deep temperature boilers',
        count: 33,
        label: 'Vitola 300',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        parentId: 'Oil boilers\u001fOil boilers floor-standing',
        count: 320,
        label: 'Oil low temperature boilers',
        hasChildren: true,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers\u001fCalorond 050',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        count: 46,
        label: 'Calorond 050',
        hasChildren: false,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers\u001fCalorond 055',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        count: 23,
        label: 'Calorond 055',
        hasChildren: false,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers\u001fVitorond 111',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        count: 115,
        label: 'Vitorond 111',
        hasChildren: false,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers\u001fVitorond 222',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        count: 177,
        label: 'Vitorond 222',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing',
        parentId: 'Oil boilers',
        count: 3572,
        label: 'Oil condensing boiler floor-standing',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitoladens 300-C',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 2002,
        label: 'Vitoladens 300-C',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitoladens 300-T',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 924,
        label: 'Vitoladens 300-T',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitorondens 200-T',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 1171,
        label: 'Vitorondens 200-T',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitorondens 222-F',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 465,
        label: 'Vitorondens 222-F',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitorondens 222-T',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 71,
        label: 'Vitorondens 222-T',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler wall-mounted',
        parentId: 'Oil boilers',
        count: 1528,
        label: 'Oil condensing boiler wall-mounted',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler wall-mounted\u001fVitoladens 300-W',
        parentId: 'Oil boilers\u001fOil condensing boiler wall-mounted',
        count: 1361,
        label: 'Vitoladens 300-W',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler wall-mounted\u001fVitoplus 300',
        parentId: 'Oil boilers\u001fOil condensing boiler wall-mounted',
        count: 190,
        label: 'Vitoplus 300',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing compact devices',
        parentId: 'Oil boilers',
        count: 877,
        label: 'Oil condensing compact devices',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil condensing compact devices\u001fVitoladens 333-F',
        parentId: 'Oil boilers\u001fOil condensing compact devices',
        count: 877,
        label: 'Vitoladens 333-F',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik',
        parentId: '',
        count: 5647,
        label: 'Photovoltaic',
        hasChildren: true,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module',
        parentId: 'Photovoltaik',
        count: 5217,
        label: 'Photovoltaic module',
        hasChildren: true,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module\u001fVitovolt 100',
        parentId: 'Photovoltaik\u001fPhotovoltaic module',
        count: 166,
        label: 'Vitovolt 100',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module\u001fVitovolt 200',
        parentId: 'Photovoltaik\u001fPhotovoltaic module',
        count: 1365,
        label: 'Vitovolt 200',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module\u001fVitovolt 300',
        parentId: 'Photovoltaik\u001fPhotovoltaic module',
        count: 3803,
        label: 'Vitovolt 300',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module\u001fVitovolt 300-DG',
        parentId: 'Photovoltaik\u001fPhotovoltaic module',
        count: 188,
        label: 'Vitovolt 300-DG',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPower storage systems',
        parentId: 'Photovoltaik',
        count: 429,
        label: 'Power storage systems',
        hasChildren: true,
      },
      {
        id: 'Photovoltaik\u001fPower storage systems\u001fBYD',
        parentId: 'Photovoltaik\u001fPower storage systems',
        count: 1,
        label: 'BYD',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPower storage systems\u001fBattery module Vitocharge VX3',
        parentId: 'Photovoltaik\u001fPower storage systems',
        count: 1,
        label: 'Battery module Vitocharge VX3',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPower storage systems\u001fVitocharge',
        parentId: 'Photovoltaik\u001fPower storage systems',
        count: 428,
        label: 'Vitocharge',
        hasChildren: false,
      },
      {
        id: 'Software',
        parentId: '',
        count: 80,
        label: 'Software',
        hasChildren: true,
      },
      {
        id: 'Software\u001fViGuide',
        parentId: 'Software',
        count: 4,
        label: 'ViGuide',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitodata 100',
        parentId: 'Software',
        count: 25,
        label: 'Vitodata 100',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitodata 300',
        parentId: 'Software',
        count: 29,
        label: 'Vitodata 300',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitoflow',
        parentId: 'Software',
        count: 10,
        label: 'Vitoflow',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitoplan 100',
        parentId: 'Software',
        count: 1,
        label: 'Vitoplan 100',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitosoft 200',
        parentId: 'Software',
        count: 14,
        label: 'Vitosoft 200',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitosoft 300',
        parentId: 'Software',
        count: 56,
        label: 'Vitosoft 300',
        hasChildren: false,
      },
      {
        id: 'Solarthermie',
        parentId: '',
        count: 3996,
        label: 'Solar Thermal',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fAccessories solar systems',
        parentId: 'Solarthermie',
        count: 6,
        label: 'Accessories solar systems',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fAccessories solar systems\u001fTyfocor',
        parentId: 'Solarthermie\u001fAccessories solar systems',
        count: 6,
        label: 'Tyfocor',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors',
        parentId: 'Solarthermie',
        count: 2667,
        label: 'Flat collectors',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fDinaSol-S',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 1,
        label: 'DinaSol-S',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fDinaSol-W',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 1,
        label: 'DinaSol-W',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 050',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 27,
        label: 'Vitosol 050',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 100',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 605,
        label: 'Vitosol 100',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 100-F',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 1231,
        label: 'Vitosol 100-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 100-FM',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 756,
        label: 'Vitosol 100-FM',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 141-FM',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 167,
        label: 'Vitosol 141-FM',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 200-F',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 2151,
        label: 'Vitosol 200-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 200-FM',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 934,
        label: 'Vitosol 200-FM',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 222-F',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 13,
        label: 'Vitosol 222-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 300-F',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 1155,
        label: 'Vitosol 300-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fThermosiphon solar systems with flat-plate collector',
        parentId: 'Solarthermie',
        count: 104,
        label: 'Thermosiphon solar systems with flat-plate collector',
        hasChildren: true,
      },
      {
        id:
          'Solarthermie\u001fThermosiphon solar systems with flat-plate collector\u001fVitosol 111-F',
        parentId: 'Solarthermie\u001fThermosiphon solar systems with flat-plate collector',
        count: 104,
        label: 'Vitosol 111-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fThermosiphon solar systems with tube collector',
        parentId: 'Solarthermie',
        count: 42,
        label: 'Thermosiphon solar systems with tube collector',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fThermosiphon solar systems with tube collector\u001fVitosol 222-T',
        parentId: 'Solarthermie\u001fThermosiphon solar systems with tube collector',
        count: 42,
        label: 'Vitosol 222-T',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors',
        parentId: 'Solarthermie',
        count: 1765,
        label: 'Vacuum tube collectors',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fDuoSol',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 4,
        label: 'DuoSol',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fTuboSol',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 3,
        label: 'TuboSol',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 200',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 332,
        label: 'Vitosol 200',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 200-T',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 882,
        label: 'Vitosol 200-T',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 200-TM',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 194,
        label: 'Vitosol 200-TM',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 250',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 57,
        label: 'Vitosol 250',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 300',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 237,
        label: 'Vitosol 300',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 300-T',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 539,
        label: 'Vitosol 300-T',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 300-TM',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 282,
        label: 'Vitosol 300-TM',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers',
        parentId: '',
        count: 5682,
        label: 'Solid fuel boilers',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers',
        parentId: 'Solid fuel boilers',
        count: 1969,
        label: 'Log wood boilers',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitolig 100',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 89,
        label: 'Vitolig 100',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitolig 200',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 101,
        label: 'Vitolig 200',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 100-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 372,
        label: 'Vitoligno 100-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 150-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 450,
        label: 'Vitoligno 150-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 200-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 586,
        label: 'Vitoligno 200-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 250-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 166,
        label: 'Vitoligno 250-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 300-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 294,
        label: 'Vitoligno 300-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers',
        parentId: 'Solid fuel boilers',
        count: 2532,
        label: 'Pellet boilers',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers\u001fVitolig 300',
        parentId: 'Solid fuel boilers\u001fPellet boilers',
        count: 174,
        label: 'Vitolig 300',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers\u001fVitoligno 200-C',
        parentId: 'Solid fuel boilers\u001fPellet boilers',
        count: 32,
        label: 'Vitoligno 200-C',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers\u001fVitoligno 300-C',
        parentId: 'Solid fuel boilers\u001fPellet boilers',
        count: 1816,
        label: 'Vitoligno 300-C',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers\u001fVitoligno 300-P',
        parentId: 'Solid fuel boilers\u001fPellet boilers',
        count: 533,
        label: 'Vitoligno 300-P',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        parentId: 'Solid fuel boilers',
        count: 1166,
        label: 'Wood chip and pellet boilers',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyroflex',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 23,
        label: 'Pyroflex',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyrot',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 29,
        label: 'Pyrot',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyrot 100',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 9,
        label: 'Pyrot 100',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyrotec',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 83,
        label: 'Pyrotec',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyrtec',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 6,
        label: 'Pyrtec',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoflex 300-H',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 14,
        label: 'Vitoflex 300-H',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoflex 300-RF',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 128,
        label: 'Vitoflex 300-RF',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoflex 300-UF',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 115,
        label: 'Vitoflex 300-UF',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoflex 300-VF',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 30,
        label: 'Vitoflex 300-VF',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoligno 300-H',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 836,
        label: 'Vitoligno 300-H',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip boilers',
        parentId: 'Solid fuel boilers',
        count: 150,
        label: 'Wood chip boilers',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip boilers\u001fLongola',
        parentId: 'Solid fuel boilers\u001fWood chip boilers',
        count: 15,
        label: 'Longola',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip boilers\u001fMono-f',
        parentId: 'Solid fuel boilers\u001fWood chip boilers',
        count: 3,
        label: 'Mono-f',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip boilers\u001fPyromat-ECO',
        parentId: 'Solid fuel boilers\u001fWood chip boilers',
        count: 132,
        label: 'Pyromat-ECO',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        parentId: 'Solid fuel boilers',
        count: 55,
        label: 'Wood chip, log and pellet boilers',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fCarbola',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 1,
        label: 'Carbola',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 23,
        label: 'Pyromat-DYN',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN 30',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 1,
        label: 'Pyromat-DYN 30',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN 45',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 19,
        label: 'Pyromat-DYN 45',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN 65',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 17,
        label: 'Pyromat-DYN 65',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN 85',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 17,
        label: 'Pyromat-DYN 85',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fVitoligno 250-F',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 32,
        label: 'Vitoligno 250-F',
        hasChildren: false,
      },
      {
        id: 'Systems',
        parentId: '',
        count: 1,
        label: 'Systems',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung',
        parentId: '',
        count: 12678,
        label: 'DHW Prod. and Hot Water Stor.',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fCombination storage tank and buffer',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 218,
        label: 'Combination storage tank and buffer',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fCombination storage tank and buffer\u001fVitocell Modular 100-VE',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fCombination storage tank and buffer',
        count: 218,
        label: 'Vitocell Modular 100-VE',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 144,
        label: 'Electric DHW production',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production',
        count: 144,
        label: 'DHW on-demand',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand\u001fVitotherm EI6',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand',
        count: 125,
        label: 'Vitotherm EI6',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand\u001fVitotron 200',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand',
        count: 19,
        label: 'Vitotron 200',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fFresh water modules',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 1834,
        label: 'Fresh water modules',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fFresh water modules\u001fVitotrans 353',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fFresh water modules',
        count: 1834,
        label: 'Vitotrans 353',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 2635,
        label: 'Buffer tank space heating',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 050',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 58,
        label: 'Vitocell 050',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 050-E EC-Pro',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 32,
        label: 'Vitocell 050-E EC-Pro',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 100-E',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 1721,
        label: 'Vitocell 100-E',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 120-E',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 255,
        label: 'Vitocell 120-E',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 140-E',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 798,
        label: 'Vitocell 140-E',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 160-E',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 638,
        label: 'Vitocell 160-E',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 657,
        label: 'Heating water buffer with DHW heating',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 320-M',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 80,
        label: 'Vitocell 320-M',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 333',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 87,
        label: 'Vitocell 333',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 340-M',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 490,
        label: 'Vitocell 340-M',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 353',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 55,
        label: 'Vitocell 353',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 360-M',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 360,
        label: 'Vitocell 360-M',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 809,
        label: 'Storage loading system',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system\u001fVitocell 100-L',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        count: 551,
        label: 'Vitocell 100-L',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system\u001fVitocell-L 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        count: 151,
        label: 'Vitocell-L 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system\u001fVitocell-L 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        count: 25,
        label: 'Vitocell-L 300',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system\u001fVitotrans 222',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        count: 282,
        label: 'Vitotrans 222',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 2571,
        label: 'Storage tank (2 coil)',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fCeraCell-bivalent',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 8,
        label: 'CeraCell-bivalent',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fRudoCell-bivalent',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 4,
        label: 'RudoCell-bivalent',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVertiCell-bivalent',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 14,
        label: 'VertiCell-bivalent',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell 100-B',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 1299,
        label: 'Vitocell 100-B',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell 100-U',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 639,
        label: 'Vitocell 100-U',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell 300-B',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 575,
        label: 'Vitocell 300-B',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell-B 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 221,
        label: 'Vitocell-B 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell-B 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 120,
        label: 'Vitocell-B 300',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 7262,
        label: 'Storage tank (1 coil)',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fCalocell-H 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 34,
        label: 'Calocell-H 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fCeraCell-H',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 15,
        label: 'CeraCell-H',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fCeraCell-W',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 5,
        label: 'CeraCell-W',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fEloCell',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'EloCell',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fHoriCell',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 88,
        label: 'HoriCell',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fHoriCell-HG',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 21,
        label: 'HoriCell-HG',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fHoriCell-HG/A',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 7,
        label: 'HoriCell-HG/A',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fHoriCell-NT',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'HoriCell-NT',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fRudoCell',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 30,
        label: 'RudoCell',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fRudoCell-V',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'RudoCell-V',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 84,
        label: 'VertiCell',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-20',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'VertiCell-20',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-8',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 6,
        label: 'VertiCell-8',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-HD',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'VertiCell-HD',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-HG',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 40,
        label: 'VertiCell-HG',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-L',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 23,
        label: 'VertiCell-L',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-NT',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 5,
        label: 'VertiCell-NT',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-WP',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'VertiCell-WP',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 442,
        label: 'Vitocell 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 100-H',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 346,
        label: 'Vitocell 100-H',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 100-V',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 1864,
        label: 'Vitocell 100-V',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 100-W',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3893,
        label: 'Vitocell 100-W',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 200-V',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 2,
        label: 'Vitocell 200-V',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 191,
        label: 'Vitocell 300',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 300-H',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 296,
        label: 'Vitocell 300-H',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 300-V',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 701,
        label: 'Vitocell 300-V',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 300-W',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 614,
        label: 'Vitocell 300-W',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-H 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 131,
        label: 'Vitocell-H 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-H 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 57,
        label: 'Vitocell-H 300',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-V 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 433,
        label: 'Vitocell-V 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-V 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 222,
        label: 'Vitocell-V 300',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-W 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 444,
        label: 'Vitocell-W 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-W 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 83,
        label: 'Vitocell-W 300',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems',
        parentId: '',
        count: 4362,
        label: 'Ventilation systems',
        hasChildren: true,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation',
        parentId: 'Ventilation systems',
        count: 3714,
        label: 'Centralized ventilation',
        hasChildren: true,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitoair',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 216,
        label: 'Vitoair',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitoair FS',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 794,
        label: 'Vitoair FS',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitoair FSI',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 278,
        label: 'Vitoair FSI',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 200-C',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 989,
        label: 'Vitovent 200-C',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 200-D',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 341,
        label: 'Vitovent 200-D',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 200-W',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 640,
        label: 'Vitovent 200-W',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 300',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 607,
        label: 'Vitovent 300',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 300-C',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 1031,
        label: 'Vitovent 300-C',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 300-F',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 515,
        label: 'Vitovent 300-F',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 300-W',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 1423,
        label: 'Vitovent 300-W',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fDecentralized ventilation',
        parentId: 'Ventilation systems',
        count: 723,
        label: 'Decentralized ventilation',
        hasChildren: true,
      },
      {
        id: 'Ventilation systems\u001fDecentralized ventilation\u001fVitovent 050-D',
        parentId: 'Ventilation systems\u001fDecentralized ventilation',
        count: 324,
        label: 'Vitovent 050-D',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fDecentralized ventilation\u001fVitovent 100',
        parentId: 'Ventilation systems\u001fDecentralized ventilation',
        count: 56,
        label: 'Vitovent 100',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fDecentralized ventilation\u001fVitovent 100-D',
        parentId: 'Ventilation systems\u001fDecentralized ventilation',
        count: 517,
        label: 'Vitovent 100-D',
        hasChildren: false,
      },
      {
        id: 'Viessmann Apps',
        parentId: '',
        count: 630,
        label: 'Viessmann Apps',
        hasChildren: true,
      },
      {
        id: 'Viessmann Apps\u001fViCare App',
        parentId: 'Viessmann Apps',
        count: 605,
        label: 'ViCare App',
        hasChildren: false,
      },
      {
        id: 'Viessmann Apps\u001fVitotrol App',
        parentId: 'Viessmann Apps',
        count: 25,
        label: 'Vitotrol App',
        hasChildren: false,
      },
      {
        id: 'Viessmann Apps\u001fVitotrol Plus App',
        parentId: 'Viessmann Apps',
        count: 25,
        label: 'Vitotrol Plus App',
        hasChildren: false,
      },
      {
        id: 'Vitoset/Merchandise',
        parentId: '',
        count: 29,
        label: 'Vitoset/Merchandise',
        hasChildren: true,
      },
      {
        id: 'Vitoset/Merchandise\u001fDomestic water production Vitoset',
        parentId: 'Vitoset/Merchandise',
        count: 29,
        label: 'Domestic water production Vitoset',
        hasChildren: true,
      },
      {
        id: 'Vitoset/Merchandise\u001fDomestic water production Vitoset\u001fVitoset Aqua',
        parentId: 'Vitoset/Merchandise\u001fDomestic water production Vitoset',
        count: 29,
        label: 'Vitoset Aqua',
        hasChildren: false,
      },
    ],
  },
];

export const assistantDeFiltersMockData: AssistantFilter[] = [
  {
    attribute: 'esc_Languages',
    label: 'Sprachen',
    dataType: 'string',
    concepts: [
      {
        id: 'da',
        parentId: '',
        count: 12137,
        label: 'Dänisch',
        hasChildren: false,
      },
      {
        id: 'de',
        parentId: '',
        count: 57876,
        label: 'Deutsch',
        hasChildren: false,
      },
      {
        id: 'en',
        parentId: '',
        count: 11027,
        label: 'Englisch',
        hasChildren: false,
      },
      {
        id: 'fi',
        parentId: '',
        count: 3176,
        label: 'Finnisch',
        hasChildren: false,
      },
      {
        id: 'fr',
        parentId: '',
        count: 49539,
        label: 'Französisch',
        hasChildren: false,
      },
      {
        id: 'it',
        parentId: '',
        count: 18539,
        label: 'Italienisch',
        hasChildren: false,
      },
      {
        id: 'nl',
        parentId: '',
        count: 25557,
        label: 'Niederländisch',
        hasChildren: false,
      },
      {
        id: 'pl',
        parentId: '',
        count: 12574,
        label: 'Polnisch',
        hasChildren: false,
      },
      {
        id: 'sv',
        parentId: '',
        count: 9685,
        label: 'Schwedisch',
        hasChildren: false,
      },
      {
        id: 'sk',
        parentId: '',
        count: 9149,
        label: 'Slowakisch',
        hasChildren: false,
      },
      {
        id: 'cs',
        parentId: '',
        count: 12967,
        label: 'Tschechisch',
        hasChildren: false,
      },
    ],
  },
  {
    attribute: 'InformationType',
    label: 'Dokumentart',
    class: 'InformationType',
    dataType: 'taxonomy',
    concepts: [
      {
        id: 'Checklists',
        parentId: '',
        count: 10925,
        label: 'Checklisten',
        hasChildren: true,
      },
      {
        id: 'Checklists\u001fVCL',
        parentId: 'Checklists',
        count: 310,
        label: 'Vertriebschecklisten',
        hasChildren: false,
      },
      {
        id: 'Checklists\u001fWCL',
        parentId: 'Checklists',
        count: 10615,
        label: 'Wartungscheckliste',
        hasChildren: false,
      },
      {
        id: 'Data sheets',
        parentId: '',
        count: 11557,
        label: 'Datenblätter',
        hasChildren: true,
      },
      {
        id: 'Data sheets\u001fSID',
        parentId: 'Data sheets',
        count: 63,
        label: 'Sicherheitsdatenblätter',
        hasChildren: false,
      },
      {
        id: 'Data sheets\u001fVDP',
        parentId: 'Data sheets',
        count: 11494,
        label: 'Datenblatt',
        hasChildren: false,
      },
      {
        id: 'General service information',
        parentId: '',
        count: 164,
        label: 'Allgemeine Serviceinformationen',
        hasChildren: false,
      },
      {
        id: 'Manuals',
        parentId: '',
        count: 137021,
        label: 'Anleitungen',
        hasChildren: true,
      },
      {
        id: 'Manuals\u001fVAB',
        parentId: 'Manuals',
        count: 567,
        label: 'Anwendungsbeispiele',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVAP',
        parentId: 'Manuals',
        count: 2887,
        label: 'Anschlussplan',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVBA',
        parentId: 'Manuals',
        count: 13117,
        label: 'Bedienungsanleitung',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVMA',
        parentId: 'Manuals',
        count: 78077,
        label: 'Montageanleitung',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVPA',
        parentId: 'Manuals',
        count: 3106,
        label: 'Planungsanleitung',
        hasChildren: false,
      },
      {
        id: 'Manuals\u001fVSA',
        parentId: 'Manuals',
        count: 39266,
        label: 'Serviceanleitung',
        hasChildren: false,
      },
      {
        id: 'Q-In-Goodwill/Recall',
        parentId: '',
        count: 1,
        label: 'Schwerpunktfehler/Rückruf',
        hasChildren: false,
      },
      {
        id: 'Solution database',
        parentId: '',
        count: 639,
        label: 'Lösungsdatenbank',
        hasChildren: true,
      },
      {
        id: 'Solution database\u001fError description',
        parentId: 'Solution database',
        count: 44,
        label: 'Fehlerbeschreibung',
        hasChildren: false,
      },
      {
        id: 'Solution database\u001fTD-Doku',
        parentId: 'Solution database',
        count: 2,
        label: 'TD-Doku',
        hasChildren: true,
      },
      {
        id: 'Solution database\u001fTD-Doku\u001fTD_Doku_010',
        parentId: 'Solution database\u001fTD-Doku',
        count: 2,
        label: 'Pumpen',
        hasChildren: false,
      },
      {
        id: 'Solution database\u001fTD-TIPs',
        parentId: 'Solution database',
        count: 1,
        label: 'TD-TIPs',
        hasChildren: false,
      },
      {
        id: 'Solution database\u001fTDT',
        parentId: 'Solution database',
        count: 1,
        label: 'Support News DE',
        hasChildren: false,
      },
      {
        id: 'Solution database\u001fWorkflow',
        parentId: 'Solution database',
        count: 593,
        label: 'Arbeitsablauf',
        hasChildren: false,
      },
      {
        id: 'VBD',
        parentId: '',
        count: 42,
        label: 'Betriebsdokument',
        hasChildren: false,
      },
      {
        id: 'VET',
        parentId: '',
        count: 5527,
        label: 'Einzelteilliste',
        hasChildren: false,
      },
      {
        id: 'VKE',
        parentId: '',
        count: 664,
        label: 'EU-Konformitätserklärung',
        hasChildren: false,
      },
      {
        id: 'Video',
        parentId: '',
        count: 30,
        label: 'Video',
        hasChildren: false,
      },
    ],
  },
  {
    attribute: 'product',
    label: 'Produkt',
    class: 'product',
    dataType: 'taxonomy',
    concepts: [
      {
        id: 'Accessories/System technology',
        parentId: '',
        count: 7561,
        label: 'Zubehör und Systemtechnik',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fCommunication',
        parentId: 'Accessories/System technology',
        count: 2301,
        label: 'Kommunikation',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fViScada Gateway',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 51,
        label: 'ViScada Gateway',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitocom 100',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 761,
        label: 'Vitocom 100',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitocom 200',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 179,
        label: 'Vitocom 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitocom 300',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 294,
        label: 'Vitocom 300',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitoconnect',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 274,
        label: 'Vitoconnect',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitoconnect 100',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 419,
        label: 'Vitoconnect 100',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitoconnect 200',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 48,
        label: 'Vitoconnect 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitogate 200',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 194,
        label: 'Vitogate 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fCommunication\u001fVitogate 300',
        parentId: 'Accessories/System technology\u001fCommunication',
        count: 262,
        label: 'Vitogate 300',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical',
        parentId: 'Accessories/System technology',
        count: 4143,
        label: 'Elektrisch',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        parentId: 'Accessories/System technology\u001fElectrical',
        count: 3702,
        label: 'Fernbedienungen',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 1351,
        label: 'Vitotrol 100',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100-E',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 198,
        label: 'Vitotrol 100-E',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100-EH',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 105,
        label: 'Vitotrol 100-EH',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100-M',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 34,
        label: 'Vitotrol 100-M',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 100-OT',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 219,
        label: 'Vitotrol 100-OT',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 200',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 307,
        label: 'Vitotrol 200',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 200-A',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 63,
        label: 'Vitotrol 200-A',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 200-E',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 227,
        label: 'Vitotrol 200-E',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 200-RF',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 261,
        label: 'Vitotrol 200-RF',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 663,
        label: 'Vitotrol 300',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300-A',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 389,
        label: 'Vitotrol 300-A',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300-B',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 178,
        label: 'Vitotrol 300-B',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300-E',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 180,
        label: 'Vitotrol 300-E',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 300-RF',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 235,
        label: 'Vitotrol 300-RF',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 350',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 42,
        label: 'Vitotrol 350',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fFernbedienungen\u001fVitotrol 350-C',
        parentId: 'Accessories/System technology\u001fElectrical\u001fFernbedienungen',
        count: 85,
        label: 'Vitotrol 350-C',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fHome Automation',
        parentId: 'Accessories/System technology\u001fElectrical',
        count: 465,
        label: 'Home Automation',
        hasChildren: true,
      },
      {
        id:
          'Accessories/System technology\u001fElectrical\u001fHome Automation\u001fVitocomfort 200',
        parentId: 'Accessories/System technology\u001fElectrical\u001fHome Automation',
        count: 93,
        label: 'Vitocomfort 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fHome Automation\u001fVitohome 200',
        parentId: 'Accessories/System technology\u001fElectrical\u001fHome Automation',
        count: 45,
        label: 'Vitohome 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fElectrical\u001fHome Automation\u001fVitohome 300',
        parentId: 'Accessories/System technology\u001fElectrical\u001fHome Automation',
        count: 108,
        label: 'Vitohome 300',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fExhaust gas',
        parentId: 'Accessories/System technology',
        count: 353,
        label: 'Abgas',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        parentId: 'Accessories/System technology\u001fExhaust gas',
        count: 353,
        label: 'Abgas/Wasser-Wärmetauscher',
        hasChildren: true,
      },
      {
        id:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger\u001fVitotrans 100-LW',
        parentId:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        count: 33,
        label: 'Vitotrans 100-LW',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger\u001fVitotrans 200-LW',
        parentId:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        count: 33,
        label: 'Vitotrans 200-LW',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger\u001fVitotrans 300',
        parentId:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        count: 291,
        label: 'Vitotrans 300',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger\u001fVitotrans 333',
        parentId:
          'Accessories/System technology\u001fExhaust gas\u001fExhaust gas/water heat exchanger',
        count: 89,
        label: 'Vitotrans 333',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic',
        parentId: 'Accessories/System technology',
        count: 799,
        label: 'Hydraulisch',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fDivicon',
        parentId: 'Accessories/System technology\u001fHydraulic',
        count: 579,
        label: 'Divicon',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fHydraulic accessories',
        parentId: 'Accessories/System technology\u001fHydraulic',
        count: 40,
        label: 'Hydraulisches Zubehör',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fHydraulic accessories\u001fVitopure',
        parentId: 'Accessories/System technology\u001fHydraulic\u001fHydraulic accessories',
        count: 40,
        label: 'Vitopure',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fPipe-bundle heat exchanger',
        parentId: 'Accessories/System technology\u001fHydraulic',
        count: 120,
        label: 'Rohrbündelwärmetauscher',
        hasChildren: true,
      },
      {
        id:
          'Accessories/System technology\u001fHydraulic\u001fPipe-bundle heat exchanger\u001fVitotrans 200',
        parentId: 'Accessories/System technology\u001fHydraulic\u001fPipe-bundle heat exchanger',
        count: 120,
        label: 'Vitotrans 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers',
        parentId: 'Accessories/System technology\u001fHydraulic',
        count: 82,
        label: 'Plattenwärmetauscher',
        hasChildren: true,
      },
      {
        id:
          'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers\u001fVitotrans 100',
        parentId: 'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers',
        count: 57,
        label: 'Vitotrans 100',
        hasChildren: false,
      },
      {
        id:
          'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers\u001fVitotrans EC-Pro',
        parentId: 'Accessories/System technology\u001fHydraulic\u001fPlate heat exchangers',
        count: 25,
        label: 'Vitotrans EC-Pro',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fOther',
        parentId: 'Accessories/System technology',
        count: 5,
        label: 'Sonstiges',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fOther\u001fContainer systems',
        parentId: 'Accessories/System technology\u001fOther',
        count: 5,
        label: 'Containeranlagen',
        hasChildren: true,
      },
      {
        id: 'Accessories/System technology\u001fOther\u001fContainer systems\u001fVitomodul',
        parentId: 'Accessories/System technology\u001fOther\u001fContainer systems',
        count: 1,
        label: 'Vitomodul',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fOther\u001fContainer systems\u001fVitomodul 200',
        parentId: 'Accessories/System technology\u001fOther\u001fContainer systems',
        count: 1,
        label: 'Vitomodul 200',
        hasChildren: false,
      },
      {
        id: 'Accessories/System technology\u001fOther\u001fContainer systems\u001fVitomodul 200-W',
        parentId: 'Accessories/System technology\u001fOther\u001fContainer systems',
        count: 4,
        label: 'Vitomodul 200-W',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems',
        parentId: '',
        count: 5458,
        label: 'Klima- und Kühlsysteme',
        hasChildren: true,
      },
      {
        id: 'Air conditioning and cooling systems\u001fAir conditioners',
        parentId: 'Air conditioning and cooling systems',
        count: 5276,
        label: 'Klimageräte',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners',
        count: 909,
        label: 'Multisplit Klimageräte',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners\u001fVitoclima 300-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners',
        count: 354,
        label: 'Vitoclima 300-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners\u001fVitoclima 300-S/HE',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fMultisplit air conditioners',
        count: 572,
        label: 'Vitoclima 300-S/HE',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners',
        count: 340,
        label: 'Single Split commercial (LCAC)',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)\u001fVitoclima 100-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)',
        count: 142,
        label: 'Vitoclima 100-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)\u001fVitoclima 242-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split commercial (LCAC)',
        count: 198,
        label: 'Vitoclima 242-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners',
        count: 1146,
        label: 'Single Split residential (RAC)',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 200-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 446,
        label: 'Vitoclima 200-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 200-S/HE',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 562,
        label: 'Vitoclima 200-S/HE',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 220-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 72,
        label: 'Vitoclima 220-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 230-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 76,
        label: 'Vitoclima 230-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)\u001fVitoclima 232-S',
        parentId:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fSingle Split residential (RAC)',
        count: 3,
        label: 'Vitoclima 232-S',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners',
        count: 3000,
        label: 'VRF commercial',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial\u001fVitoclima 333-S',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial',
        count: 1920,
        label: 'Vitoclima 333-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial\u001fVitoclima 335-S',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial',
        count: 1080,
        label: 'Vitoclima 335-S',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial\u001fVitoclima 444-S',
        parentId: 'Air conditioning and cooling systems\u001fAir conditioners\u001fVRF commercial',
        count: 108,
        label: 'Vitoclima 444-S',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems\u001fCold water sets',
        parentId: 'Air conditioning and cooling systems',
        count: 114,
        label: 'Kaltwassersätze',
        hasChildren: true,
      },
      {
        id: 'Air conditioning and cooling systems\u001fCold water sets\u001fVitoclima 200-C',
        parentId: 'Air conditioning and cooling systems\u001fCold water sets',
        count: 114,
        label: 'Vitoclima 200-C',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems\u001fCold water sets\u001fVitoclima-C',
        parentId: 'Air conditioning and cooling systems\u001fCold water sets',
        count: 15,
        label: 'Vitoclima-C',
        hasChildren: false,
      },
      {
        id: 'Air conditioning and cooling systems\u001fCommercial cooling systems',
        parentId: 'Air conditioning and cooling systems',
        count: 71,
        label: 'Kühlsysteme gewerblich',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing',
        parentId: 'Air conditioning and cooling systems\u001fCommercial cooling systems',
        count: 71,
        label: 'Deckenaggregate für Normal- und Tiefkühlung',
        hasChildren: true,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing\u001fLidl Mopro',
        parentId:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing',
        count: 29,
        label: 'Lidl Mopro',
        hasChildren: false,
      },
      {
        id:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing\u001fTecto Refrigo D',
        parentId:
          'Air conditioning and cooling systems\u001fCommercial cooling systems\u001fCeiling units for normal and deep-freezing',
        count: 42,
        label: 'Tecto Refrigo D',
        hasChildren: false,
      },
      {
        id: 'Burners',
        parentId: '',
        count: 1768,
        label: 'Brenner',
        hasChildren: true,
      },
      {
        id: 'Burners\u001fDurotwin',
        parentId: 'Burners',
        count: 6,
        label: 'Durotwin',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners',
        parentId: 'Burners',
        count: 1762,
        label: 'Ölbrenner',
        hasChildren: true,
      },
      {
        id: 'Burners\u001fOil burners\u001fCaloflame 100',
        parentId: 'Burners\u001fOil burners',
        count: 26,
        label: 'Caloflame 100',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners\u001fCaloflame 200',
        parentId: 'Burners\u001fOil burners',
        count: 25,
        label: 'Caloflame 200',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners\u001fVitoflame 100',
        parentId: 'Burners\u001fOil burners',
        count: 487,
        label: 'Vitoflame 100',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners\u001fVitoflame 200',
        parentId: 'Burners\u001fOil burners',
        count: 552,
        label: 'Vitoflame 200',
        hasChildren: false,
      },
      {
        id: 'Burners\u001fOil burners\u001fVitoflame 300',
        parentId: 'Burners\u001fOil burners',
        count: 736,
        label: 'Vitoflame 300',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas',
        parentId: '',
        count: 10371,
        label: 'Mittel- und Großkessel',
        hasChildren: true,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot and warm water boilers',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 133,
        label: 'Heiß- und Warmwassererzeuger',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fHot and warm water boilers\u001fParomat',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot and warm water boilers',
        count: 133,
        label: 'Paromat',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 369,
        label: 'Heißwassererzeuger',
        hasChildren: true,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 52,
        label: 'Turbomat',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-Duplex',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 41,
        label: 'Turbomat-Duplex',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-R',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 37,
        label: 'Turbomat-R',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-R-NH',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 6,
        label: 'Turbomat-R-NH',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-RN',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 33,
        label: 'Turbomat-RN',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fTurbomat-RN-WD',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 1,
        label: 'Turbomat-RN-WD',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fVitomax 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 189,
        label: 'Vitomax 100',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers\u001fVitomax 200-WS',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fHot water boilers',
        count: 85,
        label: 'Vitomax 200-WS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 760,
        label: 'Öl- und Gas-Brennwertkessel bodenstehend',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing\u001fVitoradial 200-C',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing',
        count: 38,
        label: 'Vitoradial 200-C',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing\u001fVitoradial 300-T',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas condensing boilers floor-standing',
        count: 735,
        label: 'Vitoradial 300-T',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas special boilers (low press steam)',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 21,
        label: 'Öl-/Gas-Spezialheizkessel (Niederdruck-Dampferzeuger)',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas special boilers (low press steam)\u001fParomat-ND',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/Gas special boilers (low press steam)',
        count: 21,
        label: 'Paromat-ND',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 991,
        label: 'Öl- und Gas-Heizkessel',
        hasChildren: true,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fDuo-Parola-e',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 3,
        label: 'Duo-Parola-e',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fDuo-Parola-eh',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 3,
        label: 'Duo-Parola-eh',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fDuo-parola-et',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 3,
        label: 'Duo-parola-et',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fParomat-RE-ND',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 5,
        label: 'Paromat-RE-ND',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fParomat-RU',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 12,
        label: 'Paromat-RU',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fRondomat',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 96,
        label: 'Rondomat',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fVitocrossal 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 490,
        label: 'Vitocrossal 100',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fVitomax 200',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 348,
        label: 'Vitomax 200',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers\u001fVitomax 300',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas boilers',
        count: 73,
        label: 'Vitomax 300',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 1055,
        label: 'Öl- und Gas-Tieftemperatur-Heizkessel',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitoCell-uniferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 11,
        label: 'VitoCell-uniferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 180,
        label: 'Vitola 100',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola 200',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 716,
        label: 'Vitola 200',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola 222',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 280,
        label: 'Vitola 222',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola-biferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 113,
        label: 'Vitola-biferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola-biferral-2',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 13,
        label: 'Vitola-biferral-2',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola-biferral-FB',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 55,
        label: 'Vitola-biferral-FB',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers\u001fVitola-biferral-RN',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas deep temperature boilers',
        count: 16,
        label: 'Vitola-biferral-RN',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 1074,
        label: 'Hochdruck-Heißwassererzeuger',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units\u001fTurbomat-RN-HW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        count: 23,
        label: 'Turbomat-RN-HW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units\u001fVitomax 200-HW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        count: 335,
        label: 'Vitomax 200-HW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units\u001fVitomax 300-HW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        count: 91,
        label: 'Vitomax 300-HW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units\u001fVitomax HW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high pressure hot water units',
        count: 679,
        label: 'Vitomax HW',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 983,
        label: 'Hochdruck-Dampferzeuger',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fTurbomat-RN-HD',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 25,
        label: 'Turbomat-RN-HD',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax 100-HS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 59,
        label: 'Vitomax 100-HS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax 200-HS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 342,
        label: 'Vitomax 200-HS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax 300-HS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 92,
        label: 'Vitomax 300-HS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax HS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 548,
        label: 'Vitomax HS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator\u001fVitomax HS-E',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas high-pressure steam generator',
        count: 28,
        label: 'Vitomax HS-E',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 1324,
        label: 'Öl-/Gas-Niederdruck-Heißwassererzeuger',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units\u001fVitomax 100-LW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        count: 186,
        label: 'Vitomax 100-LW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units\u001fVitomax 200-LW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        count: 418,
        label: 'Vitomax 200-LW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units\u001fVitomax 300-LW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        count: 124,
        label: 'Vitomax 300-LW',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units\u001fVitomax LW',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure hot water units',
        count: 834,
        label: 'Vitomax LW',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 535,
        label: 'Öl-/Gas-Niederdruck-Dampferzeuger',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator\u001fVitomax 200-LS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator',
        count: 48,
        label: 'Vitomax 200-LS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator\u001fVitomax LS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator',
        count: 27,
        label: 'Vitomax LS',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator\u001fVitoplex 100-LS',
        parentId:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low pressure steam generator',
        count: 478,
        label: 'Vitoplex 100-LS',
        hasChildren: false,
      },
      {
        id: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        parentId: 'Commercial and Industrial Boilers oil/gas',
        count: 5258,
        label: 'Öl- und Gas-Niedertemperatur-Heizkessel',
        hasChildren: true,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Duplex',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 58,
        label: 'Paromat-Duplex',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Duplex-TR',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 47,
        label: 'Paromat-Duplex-TR',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Simplex',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 139,
        label: 'Paromat-Simplex',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Triplex',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 135,
        label: 'Paromat-Triplex',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fParomat-Triplex-Z',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 41,
        label: 'Paromat-Triplex-Z',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoCell',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 77,
        label: 'VitoCell',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoCell-biferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 35,
        label: 'VitoCell-biferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoCell-comferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 29,
        label: 'VitoCell-comferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola 111',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 133,
        label: 'Vitola 111',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-biferral-e',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 27,
        label: 'Vitola-biferral-e',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-comferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 54,
        label: 'Vitola-comferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-s-e',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1,
        label: 'Vitola-s-e',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-tripass',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 33,
        label: 'Vitola-tripass',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-u-e',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 4,
        label: 'Vitola-u-e',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-u-eh',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1,
        label: 'Vitola-u-eh',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-u-et',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 3,
        label: 'Vitola-u-et',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitola-uniferral',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 56,
        label: 'Vitola-uniferral',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitomax 300-LT',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 132,
        label: 'Vitomax 300-LT',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoplex 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 764,
        label: 'Vitoplex 100',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoplex 200',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1096,
        label: 'Vitoplex 200',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitoplex 300',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1475,
        label: 'Vitoplex 300',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitorond 100',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 479,
        label: 'Vitorond 100',
        hasChildren: false,
      },
      {
        id:
          'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler\u001fVitorond 200',
        parentId: 'Commercial and Industrial Boilers oil/gas\u001fOil/gas low-temperature boiler',
        count: 1215,
        label: 'Vitorond 200',
        hasChildren: false,
      },
      {
        id: 'Controls',
        parentId: '',
        count: 8279,
        label: 'Regelungen',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control',
        parentId: 'Controls',
        count: 3775,
        label: 'Kessel− und Heizkreisregelung',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fCalotronic 200',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 34,
        label: 'Calotronic 200',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fDekamatik-DE/B',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 10,
        label: 'Dekamatik-DE/B',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fDiomatik',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 15,
        label: 'Diomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fOne Base',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 23,
        label: 'One Base',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fTetramatik-MB',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 1,
        label: 'Tetramatik-MB',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 3,
        label: 'Vitotronic',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic 200',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 3075,
        label: 'Vitotronic 200',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic 200-B',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 10,
        label: 'Vitotronic 200-B',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic 200-C',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 11,
        label: 'Vitotronic 200-C',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler and heating circuit control\u001fVitotronic 300',
        parentId: 'Controls\u001fBoiler and heating circuit control',
        count: 912,
        label: 'Vitotronic 300',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls',
        parentId: 'Controls',
        count: 3145,
        label: 'Kesselkreisregelungen',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fCalotronic 100',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 31,
        label: 'Calotronic 100',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fCalotronic 150',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 38,
        label: 'Calotronic 150',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fDuomatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 91,
        label: 'Duomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fEcotronic',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 49,
        label: 'Ecotronic',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fEurolamatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 5,
        label: 'Eurolamatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fMinomatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 13,
        label: 'Minomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fTetramatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 106,
        label: 'Tetramatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fUnomatik',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 76,
        label: 'Unomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fVitotronic 100',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 2664,
        label: 'Vitotronic 100',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fBoiler circuit controls\u001fVitotronic 150',
        parentId: 'Controls\u001fBoiler circuit controls',
        count: 90,
        label: 'Vitotronic 150',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fCascade controls',
        parentId: 'Controls',
        count: 882,
        label: 'Kaskadenregelungen',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fCascade controls\u001fVitotronic 300-K',
        parentId: 'Controls\u001fCascade controls',
        count: 726,
        label: 'Vitotronic 300-K',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fCascade controls\u001fVitotronic 333',
        parentId: 'Controls\u001fCascade controls',
        count: 178,
        label: 'Vitotronic 333',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fControl accessories',
        parentId: 'Controls',
        count: 78,
        label: 'Regelungszubehör',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fControl accessories\u001fControl panels',
        parentId: 'Controls\u001fControl accessories',
        count: 66,
        label: 'Bedieneinheiten',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fControl accessories\u001fControl panels\u001fComfortrol',
        parentId: 'Controls\u001fControl accessories\u001fControl panels',
        count: 66,
        label: 'Comfortrol',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fControl accessories\u001fSensors',
        parentId: 'Controls\u001fControl accessories',
        count: 12,
        label: 'Sensoren',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fControl accessories\u001fSensors\u001fOutdoor temperature sensor',
        parentId: 'Controls\u001fControl accessories\u001fSensors',
        count: 3,
        label: 'Außentemperatursenor',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fHeating circuit control',
        parentId: 'Controls',
        count: 757,
        label: 'Heizkreisregelung',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fHeating circuit control\u001fMotomatik',
        parentId: 'Controls\u001fHeating circuit control',
        count: 29,
        label: 'Motomatik',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fHeating circuit control\u001fVitotronic 050',
        parentId: 'Controls\u001fHeating circuit control',
        count: 249,
        label: 'Vitotronic 050',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fHeating circuit control\u001fVitotronic 200-H',
        parentId: 'Controls\u001fHeating circuit control',
        count: 492,
        label: 'Vitotronic 200-H',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSolar controls',
        parentId: 'Controls',
        count: 824,
        label: 'Solarregelungen',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fSolar controls\u001fSolartrol-E',
        parentId: 'Controls\u001fSolar controls',
        count: 5,
        label: 'Solartrol-E',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSolar controls\u001fSolartrol-M',
        parentId: 'Controls\u001fSolar controls',
        count: 4,
        label: 'Solartrol-M',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSolar controls\u001fVitosolic 100',
        parentId: 'Controls\u001fSolar controls',
        count: 447,
        label: 'Vitosolic 100',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSolar controls\u001fVitosolic 200',
        parentId: 'Controls\u001fSolar controls',
        count: 374,
        label: 'Vitosolic 200',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSystem control',
        parentId: 'Controls',
        count: 215,
        label: 'Systemsteuerung',
        hasChildren: true,
      },
      {
        id: 'Controls\u001fSystem control\u001fVitocontrol 100-M',
        parentId: 'Controls\u001fSystem control',
        count: 184,
        label: 'Vitocontrol 100-M',
        hasChildren: false,
      },
      {
        id: 'Controls\u001fSystem control\u001fVitocontrol 200-M',
        parentId: 'Controls\u001fSystem control',
        count: 31,
        label: 'Vitocontrol 200-M',
        hasChildren: false,
      },
      {
        id: 'Electric heating systems',
        parentId: '',
        count: 94,
        label: 'Elektro-Heizsysteme',
        hasChildren: true,
      },
      {
        id: 'Electric heating systems\u001fElectric Boilers',
        parentId: 'Electric heating systems',
        count: 94,
        label: 'Elektro-Heizkessel',
        hasChildren: true,
      },
      {
        id: 'Electric heating systems\u001fElectric Boilers\u001fVitotron 100',
        parentId: 'Electric heating systems\u001fElectric Boilers',
        count: 94,
        label: 'Vitotron 100',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling',
        parentId: '',
        count: 8558,
        label: 'Kraft-Wärme-Kopplung',
        hasChildren: true,
      },
      {
        id: 'Force and heat coupling\u001fCombined heat and power',
        parentId: 'Force and heat coupling',
        count: 5423,
        label: 'BHKW',
        hasChildren: true,
      },
      {
        id: 'Force and heat coupling\u001fCombined heat and power\u001fVitobloc',
        parentId: 'Force and heat coupling\u001fCombined heat and power',
        count: 160,
        label: 'Vitobloc',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fCombined heat and power\u001fVitobloc 200',
        parentId: 'Force and heat coupling\u001fCombined heat and power',
        count: 5410,
        label: 'Vitobloc 200',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via Stirling',
        parentId: 'Force and heat coupling',
        count: 1345,
        label: 'Mikro-KWK auf Stirling-Basis',
        hasChildren: true,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via Stirling\u001fMikron 300-W',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via Stirling',
        count: 15,
        label: 'Mikron 300-W',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via Stirling\u001fVitotwin 300-W',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via Stirling',
        count: 1267,
        label: 'Vitotwin 300-W',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via Stirling\u001fVitotwin 350-F',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via Stirling',
        count: 179,
        label: 'Vitotwin 350-F',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells',
        parentId: 'Force and heat coupling',
        count: 1915,
        label: 'Mikro-KWK auf Brennstoffzellen-Basis',
        hasChildren: true,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells\u001fVitovalor 300-P',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells',
        count: 563,
        label: 'Vitovalor 300-P',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells\u001fVitovalor PA2',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells',
        count: 307,
        label: 'Vitovalor PA2',
        hasChildren: false,
      },
      {
        id: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells\u001fVitovalor PT2',
        parentId: 'Force and heat coupling\u001fMicro-cogeneration via fuel cells',
        count: 1113,
        label: 'Vitovalor PT2',
        hasChildren: false,
      },
      {
        id: 'Gas boilers',
        parentId: '',
        count: 37422,
        label: 'Gas-Heizkessel',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted',
        parentId: 'Gas boilers',
        count: 3098,
        label: 'Gas-Heizkessel wandhängend',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas boilers conventional',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 745,
        label: 'Gas-Heizwert-Wandgeräte (vorher Gas-Kessel)',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas boilers conventional\u001fVitopend 100',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas boilers conventional',
        count: 745,
        label: 'Vitopend 100',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 1917,
        label: 'Gas-Kombi- oder Umlaufwassererhitzer',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters\u001fPendola',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters',
        count: 104,
        label: 'Pendola',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters\u001fVitopend 100-W',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters',
        count: 1354,
        label: 'Vitopend 100-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters\u001fVitopend 200',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi or direct water heaters',
        count: 521,
        label: 'Vitopend 200',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi unit for wall integration',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 62,
        label: 'Gas-Kombiheizer für Wandeinbau',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi unit for wall integration\u001fVitopend 100-E',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi unit for wall integration',
        count: 62,
        label: 'Vitopend 100-E',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 817,
        label: 'Gas-Kombiwasserheizer',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit\u001fVitopend 050',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit',
        count: 18,
        label: 'Vitopend 050',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit\u001fVitopend 050-W',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit',
        count: 53,
        label: 'Vitopend 050-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit\u001fVitopend 200-W',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas combi water unit',
        count: 789,
        label: 'Vitopend 200-W',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank',
        parentId: 'Gas boilers\u001fGas Boilers wall-mounted',
        count: 198,
        label: 'Gas-Wasserheizer mit Ladespeicher',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank\u001fVitopend 222',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank',
        count: 125,
        label: 'Vitopend 222',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank\u001fVitopend 222-W',
        parentId:
          'Gas boilers\u001fGas Boilers wall-mounted\u001fGas water heater with storage tank',
        count: 134,
        label: 'Vitopend 222-W',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas adsorption unit',
        parentId: 'Gas boilers',
        count: 576,
        label: 'Gas-Adsorptionsheizgeräte',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas adsorption unit\u001fVitosorp 200',
        parentId: 'Gas boilers\u001fGas adsorption unit',
        count: 51,
        label: 'Vitosorp 200',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas adsorption unit\u001fVitosorp 200-F',
        parentId: 'Gas boilers\u001fGas adsorption unit',
        count: 576,
        label: 'Vitosorp 200-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing',
        parentId: 'Gas boilers',
        count: 1898,
        label: 'Gas-Heizkessel bodenstehend',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtmola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 7,
        label: 'Atmola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtmotherm',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 3,
        label: 'Atmotherm',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 240,
        label: 'Atola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtola-Kompakt',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 25,
        label: 'Atola-Kompakt',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fAtola-RN',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 142,
        label: 'Atola-RN',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fGasola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 33,
        label: 'Gasola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fLitola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 138,
        label: 'Litola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fLitola-CL',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 27,
        label: 'Litola-CL',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fRexola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 7,
        label: 'Rexola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fRexola-biferral',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 66,
        label: 'Rexola-biferral',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fRexola-triferral',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 50,
        label: 'Rexola-triferral',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fRondola',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 3,
        label: 'Rondola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 050',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 86,
        label: 'Vitogas 050',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 100',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 528,
        label: 'Vitogas 100',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 100-F',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 415,
        label: 'Vitogas 100-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 200',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 105,
        label: 'Vitogas 200',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 200-F',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 491,
        label: 'Vitogas 200-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas boilers floor standing\u001fVitogas 300',
        parentId: 'Gas boilers\u001fGas boilers floor standing',
        count: 47,
        label: 'Vitogas 300',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas compact devices',
        parentId: 'Gas boilers',
        count: 12989,
        label: 'Gas-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        parentId: 'Gas boilers\u001fGas compact devices',
        count: 10199,
        label: 'Gas-Brennwert-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 111-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 448,
        label: 'Vitodens 111-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 111-W',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 1775,
        label: 'Vitodens 111-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 222',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 296,
        label: 'Vitodens 222',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 222-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 4954,
        label: 'Vitodens 222-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 222-W',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 3475,
        label: 'Vitodens 222-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 333',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 410,
        label: 'Vitodens 333',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit\u001fVitodens 333-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing compact unit',
        count: 1788,
        label: 'Vitodens 333-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        parentId: 'Gas boilers\u001fGas compact devices',
        count: 4320,
        label: 'Gas-Brennwert-/Solar-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitodens 141-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 187,
        label: 'Vitodens 141-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitodens 242-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 2564,
        label: 'Vitodens 242-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitodens 343',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 151,
        label: 'Vitodens 343',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitodens 343-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 1489,
        label: 'Vitodens 343-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitosolar 200-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 252,
        label: 'Vitosolar 200-F',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units\u001fVitosolar 300-F',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas condensing/Compact solar units',
        count: 636,
        label: 'Vitosolar 300-F',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas compact devices\u001fGas heating value compact unit',
        parentId: 'Gas boilers\u001fGas compact devices',
        count: 181,
        label: 'Gas-Heizwert-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas compact devices\u001fGas heating value compact unit\u001fVitopend 111-W',
        parentId: 'Gas boilers\u001fGas compact devices\u001fGas heating value compact unit',
        count: 181,
        label: 'Vitopend 111-W',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing',
        parentId: 'Gas boilers',
        count: 6374,
        label: 'Gas-Brennwertkessel bodenstehend',
        hasChildren: true,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fCondensola',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 113,
        label: 'Condensola',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVertomat',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 128,
        label: 'Vertomat',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVertomat-Simplex',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 31,
        label: 'Vertomat-Simplex',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVitocrossal',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 1189,
        label: 'Vitocrossal',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVitocrossal 200',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 1778,
        label: 'Vitocrossal 200',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler floor-standing\u001fVitocrossal 300',
        parentId: 'Gas boilers\u001fGas condensing boiler floor-standing',
        count: 4033,
        label: 'Vitocrossal 300',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        parentId: 'Gas boilers',
        count: 16573,
        label: 'Gas-Brennwertkessel wandhängend',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing boiler for wall installation',
        parentId: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        count: 362,
        label: 'Gas-Brennwertkessel für Wandeinbau',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing boiler for wall installation\u001fVitodens 100-E',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing boiler for wall installation',
        count: 362,
        label: 'Vitodens 100-E',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit',
        parentId: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        count: 1909,
        label: 'Gas-Brennwert-Kombigeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit\u001fVitodens 050-T',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit',
        count: 68,
        label: 'Vitodens 050-T',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit\u001fVitodens 050-W',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi unit',
        count: 1877,
        label: 'Vitodens 050-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        parentId: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        count: 12937,
        label: 'Gas-Brennwert-Kombi/Heizgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 286,
        label: 'Vitodens',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens 100',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 543,
        label: 'Vitodens 100',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens 100-W',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 3482,
        label: 'Vitodens 100-W',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens 200',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 1031,
        label: 'Vitodens 200',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit\u001fVitodens 200-W',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing combi/heating unit',
        count: 8976,
        label: 'Vitodens 200-W',
        hasChildren: false,
      },
      {
        id: 'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        parentId: 'Gas boilers\u001fGas condensing boiler wall-mounted',
        count: 2987,
        label: 'Gas-Brennwert-Heizgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fCondutherm',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 1,
        label: 'Condutherm',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fEurola',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 127,
        label: 'Eurola',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fEurola-CB',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 9,
        label: 'Eurola-CB',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fMirola',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 25,
        label: 'Mirola',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fVitodens 300',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 613,
        label: 'Vitodens 300',
        hasChildren: false,
      },
      {
        id:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit\u001fVitodens 300-W',
        parentId:
          'Gas boilers\u001fGas condensing boiler wall-mounted\u001fGas condensing heating unit',
        count: 2362,
        label: 'Vitodens 300-W',
        hasChildren: false,
      },
      {
        id: 'Gas-Heizkessel',
        parentId: '',
        count: 2,
        label: 'Gas-Heizkessel',
        hasChildren: true,
      },
      {
        id: 'Gas-Heizkessel\u001fGas-Kompaktgeräte',
        parentId: 'Gas-Heizkessel',
        count: 2,
        label: 'Gas-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id: 'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-/Solar-Kompaktgeräte',
        parentId: 'Gas-Heizkessel\u001fGas-Kompaktgeräte',
        count: 1,
        label: 'Gas-Brennwert-/Solar-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-/Solar-Kompaktgeräte\u001fVitodens 242-F',
        parentId: 'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-/Solar-Kompaktgeräte',
        count: 1,
        label: 'Vitodens 242-F',
        hasChildren: false,
      },
      {
        id: 'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-Kompaktgeräte',
        parentId: 'Gas-Heizkessel\u001fGas-Kompaktgeräte',
        count: 1,
        label: 'Gas-Brennwert-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id:
          'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-Kompaktgeräte\u001fVitodens 111-F',
        parentId: 'Gas-Heizkessel\u001fGas-Kompaktgeräte\u001fGas-Brennwert-Kompaktgeräte',
        count: 1,
        label: 'Vitodens 111-F',
        hasChildren: false,
      },
      {
        id: 'HEMS',
        parentId: '',
        count: 54,
        label: 'Vi Energy Management',
        hasChildren: false,
      },
      {
        id: 'Heat pumps',
        parentId: '',
        count: 19212,
        label: 'Wärmepumpen',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps',
        parentId: 'Heat pumps',
        count: 6521,
        label: 'Luft/Wasser-Wärmepumpen (Monoblock)',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 150-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 942,
        label: 'Vitocal 150-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 151-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 709,
        label: 'Vitocal 151-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 200-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 1897,
        label: 'Vitocal 200-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 200-A PRO',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 133,
        label: 'Vitocal 200-A PRO',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 222-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 533,
        label: 'Vitocal 222-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 250-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 1561,
        label: 'Vitocal 250-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 250-A Pro',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 1,
        label: 'Vitocal 250-A Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 252-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 846,
        label: 'Vitocal 252-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 300-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 1741,
        label: 'Vitocal 300-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 350',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 136,
        label: 'Vitocal 350',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fAir/water heat pumps\u001fVitocal 350-A',
        parentId: 'Heat pumps\u001fAir/water heat pumps',
        count: 955,
        label: 'Vitocal 350-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/ water/ air heat pumps',
        parentId: 'Heat pumps',
        count: 304,
        label: 'Sole/Wasser/Luft-Wärmepumpen',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fBrine/ water/ air heat pumps\u001fVitocal 300',
        parentId: 'Heat pumps\u001fBrine/ water/ air heat pumps',
        count: 304,
        label: 'Vitocal 300',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps',
        parentId: 'Heat pumps',
        count: 5911,
        label: 'Sole/Wasser-Wärmepumpen',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fNatura',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 203,
        label: 'Natura',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fSwissline',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 75,
        label: 'Swissline',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 200-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 1502,
        label: 'Vitocal 200-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 222-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 1394,
        label: 'Vitocal 222-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 242-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 756,
        label: 'Vitocal 242-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 300-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 2129,
        label: 'Vitocal 300-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 333-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 1138,
        label: 'Vitocal 333-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 343',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 141,
        label: 'Vitocal 343',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 343-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 756,
        label: 'Vitocal 343-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 350-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 1035,
        label: 'Vitocal 350-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fVitocal 350-HT Pro',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 90,
        label: 'Vitocal 350-HT Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fBrine/water heat pumps\u001fe-Natura 350-G',
        parentId: 'Heat pumps\u001fBrine/water heat pumps',
        count: 41,
        label: 'e-Natura 350-G',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fCompact-Energy-Tower',
        parentId: 'Heat pumps',
        count: 54,
        label: 'Compact-Energy-Tower',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fCompact-Energy-Tower\u001fVitotres 343',
        parentId: 'Heat pumps\u001fCompact-Energy-Tower',
        count: 54,
        label: 'Vitotres 343',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps',
        parentId: 'Heat pumps',
        count: 2021,
        label: 'Warmwasser-Wärmepumpen',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fViessmann DHW Booster HP',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 114,
        label: 'Viessmann DHW Booster HP',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 060-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 873,
        label: 'Vitocal 060-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 060-S',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 6,
        label: 'Vitocal 060-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 061-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 6,
        label: 'Vitocal 061-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 160-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 200,
        label: 'Vitocal 160-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 161-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 147,
        label: 'Vitocal 161-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 162-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 9,
        label: 'Vitocal 162-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fHot water heat pumps\u001fVitocal 262-A',
        parentId: 'Heat pumps\u001fHot water heat pumps',
        count: 851,
        label: 'Vitocal 262-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fIce energy storage',
        parentId: 'Heat pumps',
        count: 32,
        label: 'Eis-Energiespeicher',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fIce energy storage\u001fVitofriocal',
        parentId: 'Heat pumps\u001fIce energy storage',
        count: 32,
        label: 'Vitofriocal',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps',
        parentId: 'Heat pumps',
        count: 520,
        label: 'Großwärmepumpen',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 300-G Pro',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 383,
        label: 'Vitocal 300-G Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 300-G Pro SPS',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 74,
        label: 'Vitocal 300-G Pro SPS',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 300-W Pro',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 98,
        label: 'Vitocal 300-W Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 300-W Pro SPS',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 50,
        label: 'Vitocal 300-W Pro SPS',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 350-G Pro',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 178,
        label: 'Vitocal 350-G Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 350-W',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 5,
        label: 'Vitocal 350-W',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fLarge heat pumps\u001fVitocal 350-W Pro',
        parentId: 'Heat pumps\u001fLarge heat pumps',
        count: 8,
        label: 'Vitocal 350-W Pro',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps',
        parentId: 'Heat pumps',
        count: 5731,
        label: 'Split-Luft/Wasser-Wärmepumpen',
        hasChildren: true,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fNatura 200-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 52,
        label: 'Natura 200-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 100',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 51,
        label: 'Vitocal 100',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 100-A',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 337,
        label: 'Vitocal 100-A',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 100-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 806,
        label: 'Vitocal 100-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 111-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 615,
        label: 'Vitocal 111-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 200-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 3747,
        label: 'Vitocal 200-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 222-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 2190,
        label: 'Vitocal 222-S',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 222-SI',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 617,
        label: 'Vitocal 222-SI',
        hasChildren: false,
      },
      {
        id: 'Heat pumps\u001fSplit air/water heat pumps\u001fVitocal 242-S',
        parentId: 'Heat pumps\u001fSplit air/water heat pumps',
        count: 787,
        label: 'Vitocal 242-S',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices',
        parentId: '',
        count: 2386,
        label: 'Hybrid-Geräte',
        hasChildren: true,
      },
      {
        id: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation',
        parentId: 'Hybrid devices',
        count: 1853,
        label: 'Luft/Wasser-Wärmepumpen für Hybridbetrieb',
        hasChildren: true,
      },
      {
        id: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation\u001fVitocal 250-AH',
        parentId: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation',
        count: 851,
        label: 'Vitocal 250-AH',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation\u001fVitocal 250-S',
        parentId: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation',
        count: 496,
        label: 'Vitocal 250-S',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation\u001fVitocal 250-SH',
        parentId: 'Hybrid devices\u001fAir/water heat pumps/hybrid operation',
        count: 617,
        label: 'Vitocal 250-SH',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices\u001fGas hybrid compact devices',
        parentId: 'Hybrid devices',
        count: 735,
        label: 'Gas-Hybrid-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id: 'Hybrid devices\u001fGas hybrid compact devices\u001fVitocaldens 222-F',
        parentId: 'Hybrid devices\u001fGas hybrid compact devices',
        count: 735,
        label: 'Vitocaldens 222-F',
        hasChildren: false,
      },
      {
        id: 'Hybrid devices\u001fOil hybrid compact unit',
        parentId: 'Hybrid devices',
        count: 291,
        label: 'Öl-Hybrid-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id: 'Hybrid devices\u001fOil hybrid compact unit\u001fVitolacaldens 222-F',
        parentId: 'Hybrid devices\u001fOil hybrid compact unit',
        count: 291,
        label: 'Vitolacaldens 222-F',
        hasChildren: false,
      },
      {
        id: 'Light commercial ventilation systems',
        parentId: '',
        count: 318,
        label: 'Lüftungssysteme Light Commercial',
        hasChildren: true,
      },
      {
        id: 'Light commercial ventilation systems\u001fVitoair CS PRO',
        parentId: 'Light commercial ventilation systems',
        count: 160,
        label: 'Vitoair CS PRO',
        hasChildren: false,
      },
      {
        id: 'Light commercial ventilation systems\u001fVitoair CT PRO',
        parentId: 'Light commercial ventilation systems',
        count: 45,
        label: 'Vitoair CT PRO',
        hasChildren: false,
      },
      {
        id: 'Light commercial ventilation systems\u001fVitoair FS PRO',
        parentId: 'Light commercial ventilation systems',
        count: 163,
        label: 'Vitoair FS PRO',
        hasChildren: false,
      },
      {
        id: 'Oil boilers',
        parentId: '',
        count: 5639,
        label: 'Öl-Heizkessel',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing',
        parentId: 'Oil boilers',
        count: 430,
        label: 'Öl-Heizkessel bodenstehend',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers',
        parentId: 'Oil boilers\u001fOil boilers floor-standing',
        count: 77,
        label: 'Umstellbrandkessel',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers\u001fCalora 050',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers',
        count: 50,
        label: 'Calora 050',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers\u001fCalora 055',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers',
        count: 20,
        label: 'Calora 055',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers\u001fVitola 055',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fChangeover boilers',
        count: 12,
        label: 'Vitola 055',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fOil deep temperature boilers',
        parentId: 'Oil boilers\u001fOil boilers floor-standing',
        count: 33,
        label: 'Öl-Tieftemperatur Heizkessel',
        hasChildren: true,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil deep temperature boilers\u001fVitola 300',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil deep temperature boilers',
        count: 33,
        label: 'Vitola 300',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        parentId: 'Oil boilers\u001fOil boilers floor-standing',
        count: 320,
        label: 'Öl-Niedertemperatur Heizkessel',
        hasChildren: true,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers\u001fCalorond 050',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        count: 46,
        label: 'Calorond 050',
        hasChildren: false,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers\u001fCalorond 055',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        count: 23,
        label: 'Calorond 055',
        hasChildren: false,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers\u001fVitorond 111',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        count: 115,
        label: 'Vitorond 111',
        hasChildren: false,
      },
      {
        id:
          'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers\u001fVitorond 222',
        parentId: 'Oil boilers\u001fOil boilers floor-standing\u001fOil low temperature boilers',
        count: 177,
        label: 'Vitorond 222',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing',
        parentId: 'Oil boilers',
        count: 3572,
        label: 'Öl-Brennwertkessel bodenstehend',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitoladens 300-C',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 2002,
        label: 'Vitoladens 300-C',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitoladens 300-T',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 924,
        label: 'Vitoladens 300-T',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitorondens 200-T',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 1171,
        label: 'Vitorondens 200-T',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitorondens 222-F',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 465,
        label: 'Vitorondens 222-F',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler floor-standing\u001fVitorondens 222-T',
        parentId: 'Oil boilers\u001fOil condensing boiler floor-standing',
        count: 71,
        label: 'Vitorondens 222-T',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler wall-mounted',
        parentId: 'Oil boilers',
        count: 1528,
        label: 'Öl-Brennwertkessel wandhängend',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler wall-mounted\u001fVitoladens 300-W',
        parentId: 'Oil boilers\u001fOil condensing boiler wall-mounted',
        count: 1361,
        label: 'Vitoladens 300-W',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing boiler wall-mounted\u001fVitoplus 300',
        parentId: 'Oil boilers\u001fOil condensing boiler wall-mounted',
        count: 190,
        label: 'Vitoplus 300',
        hasChildren: false,
      },
      {
        id: 'Oil boilers\u001fOil condensing compact devices',
        parentId: 'Oil boilers',
        count: 877,
        label: 'Öl-Brennwert-Kompaktgeräte',
        hasChildren: true,
      },
      {
        id: 'Oil boilers\u001fOil condensing compact devices\u001fVitoladens 333-F',
        parentId: 'Oil boilers\u001fOil condensing compact devices',
        count: 877,
        label: 'Vitoladens 333-F',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik',
        parentId: '',
        count: 5647,
        label: 'Photovoltaik',
        hasChildren: true,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module',
        parentId: 'Photovoltaik',
        count: 5217,
        label: 'Photovoltaik-Module',
        hasChildren: true,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module\u001fVitovolt 100',
        parentId: 'Photovoltaik\u001fPhotovoltaic module',
        count: 166,
        label: 'Vitovolt 100',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module\u001fVitovolt 200',
        parentId: 'Photovoltaik\u001fPhotovoltaic module',
        count: 1365,
        label: 'Vitovolt 200',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module\u001fVitovolt 300',
        parentId: 'Photovoltaik\u001fPhotovoltaic module',
        count: 3803,
        label: 'Vitovolt 300',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPhotovoltaic module\u001fVitovolt 300-DG',
        parentId: 'Photovoltaik\u001fPhotovoltaic module',
        count: 188,
        label: 'Vitovolt 300-DG',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPower storage systems',
        parentId: 'Photovoltaik',
        count: 429,
        label: 'Stromspeicher-Systeme',
        hasChildren: true,
      },
      {
        id: 'Photovoltaik\u001fPower storage systems\u001fBYD',
        parentId: 'Photovoltaik\u001fPower storage systems',
        count: 1,
        label: 'BYD',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPower storage systems\u001fBattery module Vitocharge VX3',
        parentId: 'Photovoltaik\u001fPower storage systems',
        count: 1,
        label: 'Batteriemodul Vitocharge VX3',
        hasChildren: false,
      },
      {
        id: 'Photovoltaik\u001fPower storage systems\u001fVitocharge',
        parentId: 'Photovoltaik\u001fPower storage systems',
        count: 428,
        label: 'Vitocharge',
        hasChildren: false,
      },
      {
        id: 'Software',
        parentId: '',
        count: 80,
        label: 'Software',
        hasChildren: true,
      },
      {
        id: 'Software\u001fViGuide',
        parentId: 'Software',
        count: 4,
        label: 'ViGuide',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitodata 100',
        parentId: 'Software',
        count: 25,
        label: 'Vitodata 100',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitodata 300',
        parentId: 'Software',
        count: 29,
        label: 'Vitodata 300',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitoflow',
        parentId: 'Software',
        count: 10,
        label: 'Vitoflow',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitoplan 100',
        parentId: 'Software',
        count: 1,
        label: 'Vitoplan 100',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitosoft 200',
        parentId: 'Software',
        count: 14,
        label: 'Vitosoft 200',
        hasChildren: false,
      },
      {
        id: 'Software\u001fVitosoft 300',
        parentId: 'Software',
        count: 56,
        label: 'Vitosoft 300',
        hasChildren: false,
      },
      {
        id: 'Solarthermie',
        parentId: '',
        count: 3996,
        label: 'Solarthermie',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fAccessories solar systems',
        parentId: 'Solarthermie',
        count: 6,
        label: 'Zubehör Solarsysteme',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fAccessories solar systems\u001fTyfocor',
        parentId: 'Solarthermie\u001fAccessories solar systems',
        count: 6,
        label: 'Tyfocor',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors',
        parentId: 'Solarthermie',
        count: 2667,
        label: 'Flachkollektoren',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fDinaSol-S',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 1,
        label: 'DinaSol-S',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fDinaSol-W',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 1,
        label: 'DinaSol-W',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 050',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 27,
        label: 'Vitosol 050',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 100',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 605,
        label: 'Vitosol 100',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 100-F',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 1231,
        label: 'Vitosol 100-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 100-FM',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 756,
        label: 'Vitosol 100-FM',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 141-FM',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 167,
        label: 'Vitosol 141-FM',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 200-F',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 2151,
        label: 'Vitosol 200-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 200-FM',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 934,
        label: 'Vitosol 200-FM',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 222-F',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 13,
        label: 'Vitosol 222-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fFlat collectors\u001fVitosol 300-F',
        parentId: 'Solarthermie\u001fFlat collectors',
        count: 1155,
        label: 'Vitosol 300-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fThermosiphon solar systems with flat-plate collector',
        parentId: 'Solarthermie',
        count: 104,
        label: 'Thermosiphon-Solarsysteme mit Flachkollektor',
        hasChildren: true,
      },
      {
        id:
          'Solarthermie\u001fThermosiphon solar systems with flat-plate collector\u001fVitosol 111-F',
        parentId: 'Solarthermie\u001fThermosiphon solar systems with flat-plate collector',
        count: 104,
        label: 'Vitosol 111-F',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fThermosiphon solar systems with tube collector',
        parentId: 'Solarthermie',
        count: 42,
        label: 'Thermosiphon-Solarsysteme mit Röhrenkollektor',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fThermosiphon solar systems with tube collector\u001fVitosol 222-T',
        parentId: 'Solarthermie\u001fThermosiphon solar systems with tube collector',
        count: 42,
        label: 'Vitosol 222-T',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors',
        parentId: 'Solarthermie',
        count: 1765,
        label: 'Röhrenkollektoren',
        hasChildren: true,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fDuoSol',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 4,
        label: 'DuoSol',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fTuboSol',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 3,
        label: 'TuboSol',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 200',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 332,
        label: 'Vitosol 200',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 200-T',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 882,
        label: 'Vitosol 200-T',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 200-TM',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 194,
        label: 'Vitosol 200-TM',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 250',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 57,
        label: 'Vitosol 250',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 300',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 237,
        label: 'Vitosol 300',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 300-T',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 539,
        label: 'Vitosol 300-T',
        hasChildren: false,
      },
      {
        id: 'Solarthermie\u001fVacuum tube collectors\u001fVitosol 300-TM',
        parentId: 'Solarthermie\u001fVacuum tube collectors',
        count: 282,
        label: 'Vitosol 300-TM',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers',
        parentId: '',
        count: 5682,
        label: 'Festbrennstoffkessel',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers',
        parentId: 'Solid fuel boilers',
        count: 1969,
        label: 'Scheitholzkessel',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitolig 100',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 89,
        label: 'Vitolig 100',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitolig 200',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 101,
        label: 'Vitolig 200',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 100-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 372,
        label: 'Vitoligno 100-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 150-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 450,
        label: 'Vitoligno 150-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 200-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 586,
        label: 'Vitoligno 200-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 250-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 166,
        label: 'Vitoligno 250-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fLog wood boilers\u001fVitoligno 300-S',
        parentId: 'Solid fuel boilers\u001fLog wood boilers',
        count: 294,
        label: 'Vitoligno 300-S',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers',
        parentId: 'Solid fuel boilers',
        count: 2532,
        label: 'Pelletkessel',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers\u001fVitolig 300',
        parentId: 'Solid fuel boilers\u001fPellet boilers',
        count: 174,
        label: 'Vitolig 300',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers\u001fVitoligno 200-C',
        parentId: 'Solid fuel boilers\u001fPellet boilers',
        count: 32,
        label: 'Vitoligno 200-C',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers\u001fVitoligno 300-C',
        parentId: 'Solid fuel boilers\u001fPellet boilers',
        count: 1816,
        label: 'Vitoligno 300-C',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fPellet boilers\u001fVitoligno 300-P',
        parentId: 'Solid fuel boilers\u001fPellet boilers',
        count: 533,
        label: 'Vitoligno 300-P',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        parentId: 'Solid fuel boilers',
        count: 1166,
        label: 'Holzhackschnitzel- und Pelletkessel',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyroflex',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 23,
        label: 'Pyroflex',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyrot',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 29,
        label: 'Pyrot',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyrot 100',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 9,
        label: 'Pyrot 100',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyrotec',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 83,
        label: 'Pyrotec',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fPyrtec',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 6,
        label: 'Pyrtec',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoflex 300-H',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 14,
        label: 'Vitoflex 300-H',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoflex 300-RF',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 128,
        label: 'Vitoflex 300-RF',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoflex 300-UF',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 115,
        label: 'Vitoflex 300-UF',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoflex 300-VF',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 30,
        label: 'Vitoflex 300-VF',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip and pellet boilers\u001fVitoligno 300-H',
        parentId: 'Solid fuel boilers\u001fWood chip and pellet boilers',
        count: 836,
        label: 'Vitoligno 300-H',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip boilers',
        parentId: 'Solid fuel boilers',
        count: 150,
        label: 'Stückholzkessel',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip boilers\u001fLongola',
        parentId: 'Solid fuel boilers\u001fWood chip boilers',
        count: 15,
        label: 'Longola',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip boilers\u001fMono-f',
        parentId: 'Solid fuel boilers\u001fWood chip boilers',
        count: 3,
        label: 'Mono-f',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip boilers\u001fPyromat-ECO',
        parentId: 'Solid fuel boilers\u001fWood chip boilers',
        count: 132,
        label: 'Pyromat-ECO',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        parentId: 'Solid fuel boilers',
        count: 55,
        label: 'Holzhackschnitzel-, Scheitholz- und Pelletkessel',
        hasChildren: true,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fCarbola',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 1,
        label: 'Carbola',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 23,
        label: 'Pyromat-DYN',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN 30',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 1,
        label: 'Pyromat-DYN 30',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN 45',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 19,
        label: 'Pyromat-DYN 45',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN 65',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 17,
        label: 'Pyromat-DYN 65',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fPyromat-DYN 85',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 17,
        label: 'Pyromat-DYN 85',
        hasChildren: false,
      },
      {
        id: 'Solid fuel boilers\u001fWood chip, log and pellet boilers\u001fVitoligno 250-F',
        parentId: 'Solid fuel boilers\u001fWood chip, log and pellet boilers',
        count: 32,
        label: 'Vitoligno 250-F',
        hasChildren: false,
      },
      {
        id: 'Systems',
        parentId: '',
        count: 1,
        label: 'Systeme',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung',
        parentId: '',
        count: 12678,
        label: 'Trinkwassererwärmung und Heizwasserspeicherung',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fCombination storage tank and buffer',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 218,
        label: 'Kombination Speicher und Puffer',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fCombination storage tank and buffer\u001fVitocell Modular 100-VE',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fCombination storage tank and buffer',
        count: 218,
        label: 'Vitocell Modular 100-VE',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 144,
        label: 'Elektro-Warmwassersysteme',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production',
        count: 144,
        label: 'Durchlauferhitzer',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand\u001fVitotherm EI6',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand',
        count: 125,
        label: 'Vitotherm EI6',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand\u001fVitotron 200',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fElectric DHW production\u001fDHW on-demand',
        count: 19,
        label: 'Vitotron 200',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fFresh water modules',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 1834,
        label: 'Frischwasser-Module',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fFresh water modules\u001fVitotrans 353',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fFresh water modules',
        count: 1834,
        label: 'Vitotrans 353',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 2635,
        label: 'Heizwasser-Pufferspeicher',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 050',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 58,
        label: 'Vitocell 050',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 050-E EC-Pro',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 32,
        label: 'Vitocell 050-E EC-Pro',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 100-E',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 1721,
        label: 'Vitocell 100-E',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 120-E',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 255,
        label: 'Vitocell 120-E',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 140-E',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 798,
        label: 'Vitocell 140-E',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank\u001fVitocell 160-E',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer tank',
        count: 638,
        label: 'Vitocell 160-E',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 657,
        label: 'Heizwasser-Pufferspeicher mit Trinkwassererwärmung',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 320-M',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 80,
        label: 'Vitocell 320-M',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 333',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 87,
        label: 'Vitocell 333',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 340-M',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 490,
        label: 'Vitocell 340-M',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 353',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 55,
        label: 'Vitocell 353',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating\u001fVitocell 360-M',
        parentId:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fHeating water buffer with DHW heating',
        count: 360,
        label: 'Vitocell 360-M',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 809,
        label: 'Speicherladesystem',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system\u001fVitocell 100-L',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        count: 551,
        label: 'Vitocell 100-L',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system\u001fVitocell-L 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        count: 151,
        label: 'Vitocell-L 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system\u001fVitocell-L 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        count: 25,
        label: 'Vitocell-L 300',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system\u001fVitotrans 222',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage loading system',
        count: 282,
        label: 'Vitotrans 222',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 2571,
        label: 'Speicher-Wassererwärmer (bivalent)',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fCeraCell-bivalent',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 8,
        label: 'CeraCell-bivalent',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fRudoCell-bivalent',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 4,
        label: 'RudoCell-bivalent',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVertiCell-bivalent',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 14,
        label: 'VertiCell-bivalent',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell 100-B',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 1299,
        label: 'Vitocell 100-B',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell 100-U',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 639,
        label: 'Vitocell 100-U',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell 300-B',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 575,
        label: 'Vitocell 300-B',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell-B 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 221,
        label: 'Vitocell-B 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)\u001fVitocell-B 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (bivalent)',
        count: 120,
        label: 'Vitocell-B 300',
        hasChildren: false,
      },
      {
        id: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung',
        count: 7262,
        label: 'Speicher-Wassererwärmer (monovalent)',
        hasChildren: true,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fCalocell-H 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 34,
        label: 'Calocell-H 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fCeraCell-H',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 15,
        label: 'CeraCell-H',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fCeraCell-W',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 5,
        label: 'CeraCell-W',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fEloCell',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'EloCell',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fHoriCell',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 88,
        label: 'HoriCell',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fHoriCell-HG',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 21,
        label: 'HoriCell-HG',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fHoriCell-HG/A',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 7,
        label: 'HoriCell-HG/A',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fHoriCell-NT',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'HoriCell-NT',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fRudoCell',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 30,
        label: 'RudoCell',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fRudoCell-V',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'RudoCell-V',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 84,
        label: 'VertiCell',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-20',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'VertiCell-20',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-8',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 6,
        label: 'VertiCell-8',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-HD',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'VertiCell-HD',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-HG',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 40,
        label: 'VertiCell-HG',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-L',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 23,
        label: 'VertiCell-L',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-NT',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 5,
        label: 'VertiCell-NT',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVertiCell-WP',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3,
        label: 'VertiCell-WP',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 442,
        label: 'Vitocell 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 100-H',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 346,
        label: 'Vitocell 100-H',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 100-V',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 1864,
        label: 'Vitocell 100-V',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 100-W',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 3893,
        label: 'Vitocell 100-W',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 200-V',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 2,
        label: 'Vitocell 200-V',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 191,
        label: 'Vitocell 300',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 300-H',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 296,
        label: 'Vitocell 300-H',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 300-V',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 701,
        label: 'Vitocell 300-V',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell 300-W',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 614,
        label: 'Vitocell 300-W',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-H 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 131,
        label: 'Vitocell-H 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-H 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 57,
        label: 'Vitocell-H 300',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-V 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 433,
        label: 'Vitocell-V 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-V 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 222,
        label: 'Vitocell-V 300',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-W 100',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 444,
        label: 'Vitocell-W 100',
        hasChildren: false,
      },
      {
        id:
          'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)\u001fVitocell-W 300',
        parentId: 'Trinkwassererwärmung und Heizwasserspeicherung\u001fStorage tank (monovalent)',
        count: 83,
        label: 'Vitocell-W 300',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems',
        parentId: '',
        count: 4362,
        label: 'Lüftungssysteme',
        hasChildren: true,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation',
        parentId: 'Ventilation systems',
        count: 3714,
        label: 'Zentrale Wohnungslüftung',
        hasChildren: true,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitoair',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 216,
        label: 'Vitoair',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitoair FS',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 794,
        label: 'Vitoair FS',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitoair FSI',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 278,
        label: 'Vitoair FSI',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 200-C',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 989,
        label: 'Vitovent 200-C',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 200-D',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 341,
        label: 'Vitovent 200-D',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 200-W',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 640,
        label: 'Vitovent 200-W',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 300',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 607,
        label: 'Vitovent 300',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 300-C',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 1031,
        label: 'Vitovent 300-C',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 300-F',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 515,
        label: 'Vitovent 300-F',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fCentralized ventilation\u001fVitovent 300-W',
        parentId: 'Ventilation systems\u001fCentralized ventilation',
        count: 1423,
        label: 'Vitovent 300-W',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fDecentralized ventilation',
        parentId: 'Ventilation systems',
        count: 723,
        label: 'Dezentrale Wohnungslüftung',
        hasChildren: true,
      },
      {
        id: 'Ventilation systems\u001fDecentralized ventilation\u001fVitovent 050-D',
        parentId: 'Ventilation systems\u001fDecentralized ventilation',
        count: 324,
        label: 'Vitovent 050-D',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fDecentralized ventilation\u001fVitovent 100',
        parentId: 'Ventilation systems\u001fDecentralized ventilation',
        count: 56,
        label: 'Vitovent 100',
        hasChildren: false,
      },
      {
        id: 'Ventilation systems\u001fDecentralized ventilation\u001fVitovent 100-D',
        parentId: 'Ventilation systems\u001fDecentralized ventilation',
        count: 517,
        label: 'Vitovent 100-D',
        hasChildren: false,
      },
      {
        id: 'Viessmann Apps',
        parentId: '',
        count: 630,
        label: 'Viessmann Apps',
        hasChildren: true,
      },
      {
        id: 'Viessmann Apps\u001fViCare App',
        parentId: 'Viessmann Apps',
        count: 605,
        label: 'ViCare App',
        hasChildren: false,
      },
      {
        id: 'Viessmann Apps\u001fVitotrol App',
        parentId: 'Viessmann Apps',
        count: 25,
        label: 'Vitotrol App',
        hasChildren: false,
      },
      {
        id: 'Viessmann Apps\u001fVitotrol Plus App',
        parentId: 'Viessmann Apps',
        count: 25,
        label: 'Vitotrol Plus App',
        hasChildren: false,
      },
      {
        id: 'Vitoset/Merchandise',
        parentId: '',
        count: 29,
        label: 'Vitoset/Handelsware',
        hasChildren: true,
      },
      {
        id: 'Vitoset/Merchandise\u001fDomestic water production Vitoset',
        parentId: 'Vitoset/Merchandise',
        count: 29,
        label: 'Trinkwasserbereitung Vitoset',
        hasChildren: true,
      },
      {
        id: 'Vitoset/Merchandise\u001fDomestic water production Vitoset\u001fVitoset Aqua',
        parentId: 'Vitoset/Merchandise\u001fDomestic water production Vitoset',
        count: 29,
        label: 'Vitoset Aqua',
        hasChildren: false,
      },
    ],
  },
];
